<template>
  <div>
    <span class="formTitle">
      {{
        manipulateData.modalType == "product"
          ? "Produit"
          : manipulateData.modalType == "supplier"
          ? "Fournisseur"
          : manipulateData.modalType == "transitaire"
          ? "Transitaire"
          : manipulateData.modalType == "store"
          ? "Magasin"
          : manipulateData.modalType == "user"
          ? "Utilisateur"
          : manipulateData.modalType == "conteneur"
          ? "Conteneur"
          : manipulateData.modalType == "commande"
          ? "Factures"
          : manipulateData.modalType == "contrat"
          ? "Contrat"
          : manipulateData.modalType == "bl"
          ? "BL"
          : manipulateData.modalType == "addConteneur"
          ? "Conteneur"
          : manipulateData.modalType == "conteneurPrincipaleAll"
          ? "Conteneur"
          : manipulateData.modalType == "sendToStock"
          ? "Envoie dans stock"
          : manipulateData.modalType == "deleteContainer"
          ? "conteneur"
          : manipulateData.modalType == "customer"
          ? "Clients"
          : manipulateData.modalType == "customerCommande"
          ? "Commandes client"
          : manipulateData.modalType == "detailsStock"
          ? "Détails de stock"
          : manipulateData.modalType == "enterProductInStock"
          ? "Entrer de stock"
          : manipulateData.modalType == "customerPayeToCaisse"
          ? "Validation de vente"
          : manipulateData.modalType == "outProductToStock"
          ? "Sortie de produit"
          : manipulateData.modalType == "caisseCrediteCustomerBalance"
          ? "Créditer solde client"
          : manipulateData.modalType == "stockInventory"
          ? "Inventaire de stock"
          : manipulateData.modalType == "moneyRequest"
          ? "Gestion des sorties"
          : manipulateData.modalType == "videMoneyToUser"
          ? "Vider l'utilisateur"
          : manipulateData.modalType == "adminAceptRequestOutMoney"
          ? "Vider le comptable"
          : manipulateData.modalType == "editeReturnStockRow"
          ? "Retour de produit"
          : manipulateData.modalType == "editeReturnStockRowMagasin"
          ? "Retour de produit"
          : manipulateData.modalType == "editeInventoryMissedDataRow"
          ? "Validation déficit"
          : manipulateData.modalType == "showCartDetails"
          ? "Bon de commande"
          : manipulateData.modalType == "taxForBl"
          ? "Sortie en douane"
          : manipulateData.modalType == "makeSimulate"
          ? "Simulation"
          : manipulateData.modalType == "makeStartParams"
          ? "Statistique"
          : manipulateData.modalType == "adminViewManipulateAskReduct"
          ? "Demande de bonus"
          : manipulateData.modalType == "delete"
          ? "Suppression"
          : ""
      }}
    </span>
    <form
      v-if="manipulateData.modalType == 'delete'"
      @submit.prevent="handleSubmit"
    >
      <div class="alertNotification">
        <span class="material-icons-sharp mr-5"> warning </span>
        <span>{{
          `Êtes-vous sûr de vouloir supprimer cet élément du système ?`
        }}</span>
      </div>

      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Oui je veux </span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'adminViewManipulateAskReduct'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.productName"
            placeholder="Produit"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de produit</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.productType"
            placeholder="type de produit"
            required
          />
        </div>
        <div class="input-section">
          <label>Client</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.customer"
            placeholder="Client"
            required
          />
        </div>
        <div class="input-section">
          <label>Montant</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder="Montant"
            required
          />
        </div>
        <div class="input-section">
          <label>Période de simulation</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.periodeSelect"
            placeholder="Période de simulation"
            required
          />
        </div>
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.Observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div v-if="manipulateData.status != 'Acceptée'" class="contentButton">
        <div @click="submitFormAdminAccepte" class="buttonDone">
          <span> Accepter la demande</span>
        </div>
        <div
          @click="submitFormAdminReject"
          style="margin-left: 30px"
          class="buttonDoneSimulate"
        >
          <span> Rejeter la demande</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'makeStartParams'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Type de statistique</label>
          <v-autocomplete
            v-if="
              manipulateData.valueStat != 'Tracking de produit' &&
              manipulateData.valueStat != 'Tracking de BL'
            "
            @change="getSelectFilter(manipulateData.valueStat)"
            v-model="manipulateData.valueStat"
            :items="statTypeListeData"
            rounded
          ></v-autocomplete>
          <v-autocomplete
            v-if="
              manipulateData.valueStat == 'Tracking de produit' ||
              manipulateData.valueStat == 'Tracking de BL'
            "
            @change="getSelectFilter(manipulateData.valueStat)"
            v-model="manipulateData.valueStat"
            :items="statTypeListeDataOn"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('product', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Produit</label>
          <v-autocomplete
            v-model="manipulateData.product"
            :items="productDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Taxe', manipulateData.valueStat)"
          class="input-section"
        >
          <label> Type de taxe <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.typeOfTaxeAll"
            :items="typeOfTaxeAll"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Transitaire', manipulateData.valueStat)"
          class="input-section"
        >
          <label> Transitaire <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.transitaire"
            :items="transitaireDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Navire', manipulateData.valueStat)"
          class="input-section"
        >
          <label> Navire <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.shipName"
            :items="navireListe"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Fournisseur', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Fournisseur <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.supplier"
            :items="supplierTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Client', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.customer"
            :items="customerListDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Magasin', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Magasin</label>
          <v-autocomplete
            v-model="manipulateData.store"
            :items="storeDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('BL', manipulateData.valueStat)"
          class="input-section"
        >
          <label> Numéro bl <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.bl"
            :items="blDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Facture', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Facture <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.contractDetail"
            :items="contratDataDetailsTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Pays', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Pays <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.country"
            :items="CuntryListe"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Compte', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Type de compte <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.paymentMethod"
            :items="paymentMethods"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="getIfShow('Paiement', manipulateData.valueStat)"
          class="input-section"
        >
          <label>Mode de paiement <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.paymentMethod"
            :items="paymentMethods"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label>Début de période</label>
          <input
            type="date"
            v-model="manipulateData.startDate"
            placeholder="Début de période"
            required
          />
        </div>
        <div class="input-section">
          <label>Fin de période</label>
          <input
            type="date"
            v-model="manipulateData.endDate"
            placeholder="Fin de période"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Charger les données</span>
        </div>
      </div>
      <div v-if="statLink" class="separation"></div>
      <div v-if="statPatch && !statLink" class="contentButton">
        <v-btn
          @click="makeExportPDF(statPatch)"
          style="margin-left: 30px"
          class="buttonDoneSimulate"
        >
          <span> Télécharger le rapport </span>
        </v-btn>
      </div>
      <div v-if="statLink && !statPatch" class="contentButton">
        <v-btn
          @click="makeExport"
          style="margin-left: 30px"
          class="buttonDoneSimulate"
        >
          <span> Exportation des données </span>
        </v-btn>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'makeSimulate'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <v-autocomplete
            v-model="manipulateData.product"
            :items="productDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label>Client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.customer"
            :items="customerListDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label>Début de période</label>
          <input
            type="date"
            v-model="manipulateData.startDate"
            placeholder="Début de période"
            required
          />
        </div>
        <div class="input-section">
          <label>Fin de période</label>
          <input
            type="date"
            v-model="manipulateData.endDate"
            placeholder="Fin de période"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Lancer la simulation</span>
        </div>
      </div>
      <div class="separation"></div>
      <span class="formTitle">Accorder Bonus</span>
      <div class="fileForm">
        <div class="input-section">
          <label>Montant bonus</label>
          <input
            type="number"
            v-model="manipulateData.amount"
            placeholder="Montant bonus"
            required
          />
        </div>
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div
          style="margin-left: 30px"
          @click="submitFormAdminAccepte"
          class="buttonDoneSimulate"
        >
          <span> Appliqué le bonus </span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'showCartDetails'"
      class=""
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormSecond">
        <div class="input-section">
          <label> Client <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.customer"
            disabled
            class="disabled"
            placeholder="Client"
            required
          />
        </div>
        <div class="input-section">
          <label>Total vente <span class="required-color">*</span></label>
          <input
            type="text"
            v-model="manipulateData.amount"
            disabled
            class="disabled"
            placeholder="Total vente"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Date d'expiration <span class="required-color">*</span>
          </label>
          <input
            type="date"
            disabled
            class="disabled"
            v-model="manipulateData.expiredAt"
            placeholder="Date d'expiration"
            required
          />
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.observation"
            placeholder="Description"
            required
          />
        </div>
      </div>
      <div
        v-if="manipulateData.status == 'Attente'"
        @click="addNewMinusCart"
        style="margin-left: 30px"
        class="buttonAdd"
      >
        <span> Ajouter plus de produits</span>
      </div>
      <div class="flex">
        <div
          @click="printBonFunction"
          style="margin-left: 30px"
          class="buttonDelete"
        >
          <span> Imprimer le bon de commande</span>
        </div>
        <div
          @click="sendToCaisseFunction"
          style="margin-right: 30px"
          :class="
            sentToCashRegisterBy != '' ? 'buttonAddSecond' : 'buttonDisabled'
          "
          v-if="manipulateData.status == 'Attente'"
          :disabled="sentToCashRegisterBy != '' ? true : false"
        >
          <span> Envoyer à la caisse</span>
        </div>
      </div>

      <div
        style="margin-left: 30px; margin-right: 30px; width: calc(100% - 60px)"
        class="contentLists"
      >
        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeaderForCardDetail" :key="item">
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="
                manipulateData.status == 'Attente'
                  ? editNewMinusCartDetail(item)
                  : ' '
              "
              v-for="item in cardDetails"
              :key="item._id"
              :class="item.isSelected === true ? 'active' : 'noActive'"
            >
              <td>
                {{ item.product ? item.product.name : "" }}
              </td>
              <td>
                {{ item.product ? item.product.type : "" }}
              </td>
              <td>
                {{ item.product ? item.product.unitPrice : "" }}
              </td>
              <td>{{ item.quantity }}</td>
              <!-- <td>{{ item.product.unitPrice * item.quantity }}</td> -->
              <!-- <td>{{ item.reduction }}</td> -->
              <td>{{ item.amount }}</td>
              <td>{{ item.store ? item.store.name : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'editeInventoryMissedDataRow'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <!-- <v-autocomplete
            v-model="manipulateData.productName"
            disabled
            class="disabled"
            :items="productDataTypeNameList"
            rounded
          ></v-autocomplete> -->
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.productName"
            placeholder="Produit"
            required
          />
        </div>

        <div class="input-section">
          <label>Magasin</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.store"
            placeholder="Magasin"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de déficit</label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.isSurPlus"
            placeholder="Type de déficit"
            required
          />
        </div>
        <div class="input-section">
          <label>Quantité déficit</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.quantity"
            placeholder="Quantité perdue"
            required
          />
        </div>
        <div v-if="manipulateData.imageLink" class="input-section">
          <label>Preuve de déficit</label>
          <img :src="manipulateData.imageLink" alt="" />
        </div>

        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            :disabled="
              manipulateData.status == 'Acceptée' &&
              manipulateData.status == 'Rejetée'
            "
            :class="
              manipulateData.status == 'Acceptée' ||
              manipulateData.status == 'Rejetée'
                ? 'disabled'
                : ''
            "
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div
        v-if="
          manipulateData.status != 'Acceptée' &&
          manipulateData.status != 'Rejetée'
        "
        class="contentButton"
      >
        <div @click="submitFormAdminAccepte" class="buttonDone">
          <span> Accepter le retour en stock</span>
        </div>
        <div
          style="margin-left: 30px"
          @click="submitFormAdminReject"
          class="buttonDoneSimulate"
        >
          <span> Rejeter le retour en stock</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'editeReturnStockRowMagasin'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <v-autocomplete
            v-model="manipulateData.product"
            disabled
            class="disabled"
            :items="productDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label>Quantité retournée</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.quantity"
            placeholder="Quantité retournée"
            required
          />
        </div>

        <div class="input-section">
          <label>Client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.customer"
            disabled
            class="disabled"
            :items="customerListDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitFormAdminAccepte" class="buttonDone">
          <span> Accepter le retour en stock</span>
        </div>
        <div
          style="margin-left: 30px"
          @click="submitFormAdminReject"
          class="buttonDoneSimulate"
        >
          <span> Rejeter le retour en stock</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'editeReturnStockRow'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <v-autocomplete
            v-model="manipulateData.product"
            :items="productDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label>Quantité retournée</label>
          <input
            type="number"
            v-model="manipulateData.quantity"
            placeholder="Quantité retournée"
            required
          />
        </div>
        <div class="input-section">
          <label>Magasin de retour</label>
          <v-autocomplete
            v-model="manipulateData.store"
            :items="storeDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label>Client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.customer"
            :items="customerListDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <!-- <div class="input-section">
          <label> Montant <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.amount"
            placeholder=" Montant"
            required
          />
        </div> -->

        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'adminAceptRequestOutMoney'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>
            Libellé de transaction <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.label"
            disabled
            class="disabled"
            placeholder="Libellé de transaction"
            required
          />
        </div>
        <div class="input-section">
          <label> Montant <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder=" Montant"
            required
          />
        </div>

        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="test"
            disabled
            class="disabled"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
        <div v-if="manipulateData.imageLink" class="input-section">
          <label>Fichier de preuve </label>
          <img :src="manipulateData.imageLink" alt="" />
        </div>
      </div>

      <div
        v-if="!manipulateData.imageLink && manipulateData.status != 'Acceptée'"
        class="contentButton"
      >
        <div @click="submitFormAdminAccepte" class="buttonDone">
          <span> Accepter la demande</span>
        </div>
      </div>
      <div
        v-if="!manipulateData.imageLink && manipulateData.status != 'Acceptée'"
        class="contentButton"
      >
        <div
          @click="submitFormAdminReject"
          style="margin-left: 30px"
          class="buttonDoneSimulate"
        >
          <span> Rejeter la demande</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'videMoneyToUser'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>
            Nom de l'utilisateur <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.fullName"
            disabled
            class="disabled"
            placeholder="Libellé de transaction"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Poste de l'utilisateur <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.jobTitle"
            disabled
            class="disabled"
            placeholder="Poste de l'utilisateur"
            required
          />
        </div>

        <div
          v-for="item in manipulateData.paymentMethods"
          :key="item"
          class="input-section"
        >
          <label>
            Solde disponible {{ item.paymentMethod }}
            <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="item.balance"
            disabled
            class="disabled"
            placeholder="Solde disponible"
            required
          />
        </div>
        <div class="input-section">
          <label
            >Type de compte a vider <span class="required-color">*</span></label
          >
          <v-autocomplete
            v-model="manipulateData.paymentMethod"
            :items="paymentMethods"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Montant à vider <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.amount"
            placeholder="Montant à vider"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Vider le compte</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'moneyRequest'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>
            Libellé de transaction <span class="required-color">*</span>
          </label>
          <input
            type="text"
            :class="manipulateData.status == 'Acceptée' ? 'disabled' : ''"
            :disabled="manipulateData.status == 'Acceptée' ? true : false"
            v-model="manipulateData.label"
            placeholder="Libellé de transaction"
            required
          />
        </div>
        <div class="input-section">
          <label
            >Type de compte
            <span class="required-color">*</span>
          </label>
          <v-autocomplete
            :class="manipulateData.status == 'Acceptée' ? 'disabled' : ''"
            :disabled="manipulateData.status == 'Acceptée' ? true : false"
            v-model="manipulateData.paymentMethod"
            :items="paymentMethods"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Montant <span class="required-color">*</span> </label>
          <input
            type="number"
            :class="manipulateData.status == 'Acceptée' ? 'disabled' : ''"
            :disabled="manipulateData.status == 'Acceptée' ? true : false"
            v-model="manipulateData.amount"
            placeholder=" Montant"
            required
          />
        </div>
        <div v-if="manipulateData.imageLink" class="input-section">
          <label>Fichier de preuve </label>
          <img :src="manipulateData.imageLink" alt="" />
        </div>

        <div
          v-if="
            manipulateData.status == 'Acceptée' && !manipulateData.imageLink
          "
          class="input-section"
        >
          <label>
            Fichier de preuve <span class="required-color">*</span>
          </label>
          <input
            type="file"
            multiple
            v-on:change="manipulateData.files = $event.target.files"
            placeholder="Fichier de preuve"
            required
          />
        </div>
        <div v-if="!manipulateData.imageLink" class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="test"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div v-if="!manipulateData.imageLink" class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'outProductToStock'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>
            Bon de commande No <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.number"
            disabled
            class="disabled"
            placeholder="Bon de commande No"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Quantité à déstocker <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.quantityLessToRemoved"
            disabled
            class="disabled"
            placeholder=" Quantité à déstocker"
            required
          />
        </div>
        <div
          v-if="manipulateData.quantityLessToRemoved == 0"
          class="input-section"
        >
          <label>
            Quantité déstockée <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.quantityRemoved"
            disabled
            class="disabled"
            placeholder=" Quantité déstockée"
            required
          />
        </div>

        <div
          v-if="manipulateData.quantityLessToRemoved > 0"
          class="input-section"
        >
          <label>
            Quantité déstockée <span class="required-color">*</span>
          </label>
          <input
            type="number"
            @input="cheekSotckMax()"
            v-model="manipulateData.quantity"
            placeholder="Quantité déstockée"
            required
          />
        </div>

        <div
          v-if="manipulateData.quantityLessToRemoved > 0"
          class="input-section"
        >
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="test"
            @input="cheekSotckMax()"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div
        v-if="manipulateData.quantityLessToRemoved > 0"
        class="contentButton"
      >
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'customerPayeToCaisse'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Client <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.name"
            disabled
            class="disabled"
            placeholder="Client"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Bon de commande No <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.number"
            disabled
            class="disabled"
            placeholder="Bon de commande No"
            required
          />
        </div>
        <div class="input-section">
          <label> Total vente <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.amount"
            disabled
            class="disabled"
            placeholder="Total vente"
            required
          />
        </div>
        <div class="input-section">
          <label>Mode de paiement <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.paymentMethod"
            :items="paymentMethods"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Portefeuille' ||
            manipulateData.paymentMethod === 'À crédit'
          "
          class="input-section"
        >
          <label>Solde actuel <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.balance"
            disabled
            class="disabled"
            placeholder="Solde actuel"
            required
          />
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Espèces' ||
            manipulateData.paymentMethod === 'Chèque' ||
            manipulateData.paymentMethod === 'Virement'
          "
          class="input-section"
        >
          <label> Montant<span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.creditAmount"
            placeholder="Montant"
            required
          />
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Chèque' ||
            manipulateData.paymentMethod === 'Virement'
          "
          class="input-section"
        >
          <label
            >{{
              manipulateData.paymentMethod == "Chèque"
                ? "Numéro de chèque"
                : "Numéro d'ordre de virement"
            }}
            <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.banqueAccountNumber"
            :placeholder="
              manipulateData.paymentMethod == 'Chèque'
                ? 'Numéro de chèque'
                : 'Numéro ordre de virement'
            "
            required
          />
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Chèque' ||
            manipulateData.paymentMethod === 'Virement'
          "
          class="input-section"
        >
          <label
            >{{
              manipulateData.paymentMethod == "Chèque"
                ? "Banque du chèque"
                : "Banque d'ordre de virement"
            }}
            <span class="required-color">*</span>
          </label>
          <v-autocomplete
            v-model="manipulateData.banque"
            :items="itemsBank"
            rounded
          ></v-autocomplete>
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'caisseCrediteCustomerBalance'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Client <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.customerName"
            disabled
            class="disabled"
            placeholder="Client"
            required
          />
        </div>
        <div class="input-section">
          <label>Solde actuel <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.balance"
            disabled
            class="disabled"
            placeholder="Solde actuel"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Montant à créditer<span class="required-color">*</span>
          </label>
          <input
            type="number"
            v-model="manipulateData.amount"
            placeholder="Montant à créditer"
            required
          />
        </div>
        <div class="input-section">
          <label> Motif de dépot<span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Motif de dépot"
            required
          />
        </div>
        <div class="input-section">
          <label>Mode de paiement <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.paymentMethod"
            :items="paymentMethodsAdd"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Chèque' ||
            manipulateData.paymentMethod === 'Virement'
          "
          class="input-section"
        >
          <label
            >{{
              manipulateData.paymentMethod == "Chèque"
                ? "Numéro de chèque"
                : "Numéro d'ordre de virement"
            }}
            <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.banqueAccountNumber"
            :placeholder="
              manipulateData.paymentMethod == 'Chèque'
                ? 'Numéro de chèque'
                : 'Numéro ordre de virement'
            "
            required
          />
        </div>
        <div
          v-if="
            manipulateData.paymentMethod === 'Chèque' ||
            manipulateData.paymentMethod === 'Virement'
          "
          class="input-section"
        >
          <label
            >{{
              manipulateData.paymentMethod == "Chèque"
                ? "Banque du chèque"
                : "Banque d'ordre de virement"
            }}
            <span class="required-color">*</span>
          </label>
          <v-autocomplete
            v-model="manipulateData.banque"
            :items="itemsBank"
            rounded
          ></v-autocomplete>
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'product'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Nom <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Nom"
            required
          />
        </div>
        <!-- <div class="input-section">
          <label> Type <span class="required-color">*</span> </label>
          <input type="text" v-model="manipulateData.type" placeholder="Type" required />
        </div> -->
        <div class="input-section">
          <label>Type <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.type"
            :items="items"
            rounded
          ></v-autocomplete>
        </div>
        <!-- <div class="input-section">
          <label> Unité de Mesure <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.unitOfMeasurement"
            placeholder="Unité de Mesure"
            required
          />
        </div> -->
        <div class="input-section">
          <label>Unité de mesure <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.unitOfMeasurement"
            :items="unitItems"
            rounded
          ></v-autocomplete>
        </div>
        <div
          v-if="
            UserProfile.role == 'Responsable financier' ||
            UserProfile.role == 'Administrateur'
          "
          class="input-section"
        >
          <label> Prix Unitaire <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.unitPrice"
            placeholder="Prix Unitaire"
            required
          />
        </div>
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
        <!-- <div class="input-section">
                
                <label>Préférence  <span class="required-color">*</span></label>
                <select
                  v-model="manipulateData.Competences"
                  :items="items"
                  outlined
                ></select>
              </div>
      </div> -->
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'supplier'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Nom <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.fullName"
            placeholder="Nom"
            required
          />
        </div>
        <div class="input-section">
          <label> Téléphone <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.phones"
            placeholder="Téléphone"
            required
          />
        </div>
        <div class="input-section">
          <label> mail <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.email"
            placeholder="mail"
            required
          />
        </div>
        <div class="input-section">
          <label>Pays <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.country"
            :items="CuntryListe"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Correspondant <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.personContactName"
            placeholder="Correspondant"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Téléphone correspondant<span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.personContactPhone"
            placeholder="Téléphone correspondant"
            required
          />
        </div>
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'transitaire'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Nom <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.fullName"
            placeholder="Nom"
            required
          />
        </div>
        <div class="input-section">
          <label> Téléphone <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.phones"
            placeholder="Téléphone"
            required
          />
        </div>
        <div class="input-section">
          <label> mail <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.email"
            placeholder="mail"
            required
          />
        </div>
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'store'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label> Nom <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Nom"
            required
          />
        </div>
        <div class="input-section">
          <label> Adresse <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.address"
            placeholder="Adresse"
            required
          />
        </div>
        <div class="input-section">
          <label> Téléphone <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.phones"
            placeholder="Téléphone"
            required
          />
        </div>
        <div class="input-section">
          <label> Responsable <span class="required-color">*</span> </label>
          <v-autocomplete
            v-model="manipulateData.responsible"
            :items="userDataTypeNameList"
            rounded
          ></v-autocomplete>
          <!-- <input
            type="text"
            v-model="manipulateData.responsible"
            placeholder="Responsable"
            required
          /> -->
        </div>
        <!-- {{manipulateData}} -->
        <div class="contentButton">
          <div @click="checkLocation" class="buttonDoneSimulate">
            <span> Vérifier la localisation</span>
          </div>
        </div>
        <div class="input-section">
          <label> Longitude <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.longitude"
            placeholder="Longitude"
            required
          />
        </div>
        <div class="input-section">
          <label> Latitude <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="manipulateData.latitude"
            placeholder="Latitude"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'user'"
      @submit.prevent="handleSubmit"
    >
      <!-- {{manipulateData.stores}} -->
      <div class="fileForm">
        <div class="input-section">
          <label
            >Type d'utilisateur <span class="required-color">*</span></label
          >
          <v-autocomplete
            v-model="manipulateData.role"
            :items="roleListe"
            @change="checkIfHaveStore(manipulateData.role)"
            rounded
          ></v-autocomplete>
        </div>
        <div v-if="showElement" class="input-section">
          <label>Magasin <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.stores"
            :items="storeDataTypeNameList"
            rounded
            multiple
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label> Nom Complet <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.fullName"
            placeholder="Nom Complet"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Numéro de téléphone <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.username"
            placeholder="Numéro de téléphone"
            required
          />
        </div>
        <div class="input-section">
          <label> Email <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.email"
            placeholder="Email"
            required
          />
        </div>

        <!-- <div class="input-section">
          <label>
            Intitulé de post <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.jobTitle"
            placeholder="Intitulé de post"
            required
          />
        </div> -->
        <div v-if="manipulateData._id" class="input-section">
          <label> Mot de passe <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.password"
            placeholder="Mot de passe"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'conteneur'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Type de conteneur <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.name"
            :items="conteneurItemsDataType"
            @change="makeNewFilters()"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Description <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.description"
            placeholder="Description"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'commande'"
      class=""
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormSecond">
        <div class="input-section">
          <label>
            Numéro de contrat <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.number"
            disabled
            class="disabled"
            placeholder="Numéro de contrat"
            required
          />
        </div>
        <div class="input-section">
          <label>Fournisseur <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.supplier"
            :items="supplierTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.observation"
            placeholder="Description"
            required
          />
        </div>
      </div>

      <div
        @click="addNewMinusContrat"
        style="margin-left: 30px"
        class="buttonAdd"
      >
        <span> Ajouter une facture</span>
      </div>
      <div
        style="margin-left: 30px; margin-right: 30px; width: calc(100% - 60px)"
        class="contentLists"
      >
        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeader" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="item.isSelected === true ? 'active' : 'noActive'"
              v-for="item in contratDataDetails"
              :key="item._id"
            >
              <td>
                <div class="nameContentButton">
                  <div @click="duplicateItem(item)" class="buttonAddSecond">
                    <span> Dupliquer</span>
                  </div>
                </div>
              </td>
              <td @click="editNewMinusContrat(item)">
                {{ raccourcirTexte(item.product ? item.product.name : "") }}
              </td>
              <td @click="editNewMinusContrat(item)">
                {{ raccourcirTexte(item.number) }}
              </td>
              <td @click="editNewMinusContrat(item)">{{ item.quantity }}</td>
              <td @click="editNewMinusContrat(item)">{{ item.amount }}</td>
              <!-- <td>{{ item.fcl }}</td>
              <td>{{ raccourcirTexte(item.referenceReservation) }}</td> -->
              <!-- <td>{{ raccourcirTexte(item.observation) }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'taxForBl'"
      class=""
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormSecond">
        <div class="input-section">
          <label> Numéro de Bl <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.number"
            disabled
            class="disabled"
            placeholder="Numéro de Bl"
            required
          />
        </div>
        <div class="input-section">
          <label
            >Nombre de conteneur <span class="required-color">*</span></label
          >
          <input
            type="text"
            v-model="manipulateData.totalContainer"
            disabled
            class="disabled"
            placeholder="Nombre de conteneur"
            required
          />
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.observation"
            placeholder="Description"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Total Transitaire <span class="required-color">*</span>
          </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="totalTansitSaveDatavalue"
            placeholder="Total taxe"
            required
          />
        </div>
        <div class="input-section">
          <label> Total taxe <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="totalTaxevalue"
            placeholder="Total taxe"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Total autres taxes <span class="required-color">*</span>
          </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="totalOtherTaxevalue"
            placeholder="Total autre surtaxe"
            required
          />
        </div>
      </div>

      <div
        @click="addNewMinusContainer"
        style="margin-left: 30px"
        class="buttonAdd"
      >
        <span> Ajouter une dépense</span>
      </div>

      <div
        style="margin-left: 30px; margin-right: 30px; width: calc(100% - 60px)"
        class="contentLists"
      >
        <h1 class="mt-10 mb-5">Liste des transits</h1>

        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeaderTransite" :key="item">
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="item.isSelected === true ? 'active' : 'noActive'"
              @click="editNewMinusContainer(item, 'Transit')"
              v-for="item in tansitSaveData"
              :key="item._id"
            >
              <!-- <td>
        {{ item.isOtherTax == true ? "Surtaxe" : "Taxe" }}
      </td> -->
              <td>
                {{ raccourcirTexte(item.name) }}
              </td>
              <td>{{ item.amount }}</td>
            </tr>
          </tbody>
        </table>

        <h1 class="mt-10 mb-5">Liste des taxes</h1>

        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeaderTaxe" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="item.isSelected === true ? 'active' : 'noActive'"
              @click="editNewMinusContainer(item, 'Taxe')"
              v-for="item in taxData"
              :key="item._id"
            >
              <!-- <td>
                {{ item.isOtherTax == true ? "Surtaxe" : "Taxe" }}
              </td> -->
              <td>
                {{ raccourcirTexte(item.name) }}
              </td>
              <td>{{ item.numberOfDays }}</td>
              <td>{{ item.amount }}</td>
            </tr>
          </tbody>
        </table>
        <h1 class="mt-10 mb-5">Liste des autres Taxes</h1>
        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeaderTaxe" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="item.isSelected === true ? 'active' : 'noActive'"
              @click="editNewMinusContainer(item, 'Autres ...')"
              v-for="item in taxDataOther"
              :key="item._id"
            >
              <!-- <td>
                {{ item.isOtherTax == true ? "Surtaxe" : "Taxe" }}
              </td> -->
              <td>
                {{ raccourcirTexte(item.name) }}
              </td>
              <td>{{ item.numberOfDays }}</td>
              <td>{{ item.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'contrat'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>
            Numéro de contrat <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.number"
            placeholder="Numéro de contrat"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Date de mis en place <span class="required-color">*</span>
          </label>
          <input
            type="date"
            v-model="value.implementationDate"
            placeholder="Date de mis en place"
            required
          />
        </div>
        <div class="input-section">
          <label>Fournisseur <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.supplier"
            :items="supplierTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Description"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'bl'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Facture <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.contractDetail"
            :items="contratDataDetailsTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Numéro BL <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.number"
            placeholder="Numéro BL"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Port de chargement <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.loadingPort"
            placeholder="Port de chargement"
            required
          />
        </div>
        <div class="input-section">
          <label> Navire <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.shipName"
            placeholder="Navire"
            required
          />
        </div>
        <div class="input-section">
          <label> Ligne <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.lineName"
            placeholder="Ligne"
            required
          />
        </div>
        <div class="input-section">
          <label> Destination <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.destination"
            placeholder="Destination"
            required
          />
        </div>
        <div class="input-section">
          <label> Etd <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.etdPol"
            placeholder="Etdpol"
            required
          />
        </div>
        <div class="input-section">
          <label> ETA <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.eta"
            placeholder="ETA"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Dernière position du navire <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.lastPosition"
            placeholder="Dernière position du navire"
            required
          />
        </div>
        <div class="input-section">
          <label> Transitaire <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.transitaire"
            :items="transitaireDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div v-if="manipulateData._id" class="input-section">
          <label>
            Montant transitaire <span class="required-color">*</span>
          </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.transitaireAmount"
            placeholder="Montant transitaire"
            required
          />
        </div>
        <div v-if="manipulateData._id" class="input-section">
          <label>P. U. B. <span class="required-color">*</span> </label>
          <input
            type="number"
            class="disabled"
            disabled
            v-model="manipulateData.unitCoastPrice"
            placeholder="P. U. B."
            required
          />
        </div>
        <div v-if="manipulateData._id" class="input-section">
          <label
            >Temps d'exécution du contrat <span class="required-color">*</span>
          </label>
          <input
            type="number"
            class="disabled"
            disabled
            v-model="manipulateData.contractExecutionDelay"
            placeholder="Temps d'exécution du contrat"
            required
          />
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <span v-if="!value._id && value.modalType == 'bl'" class="formTitle">
        {{ value.modalType == "bl" ? "Conteneur" : "" }}
      </span>
      <!-- <div
        v-if="!value._id && value.modalType == 'bl'"
        class="listeDynamicContent"
      >
        <div v-if="formTypes.length === 0">
          <div @click="addIdForConteneurListe()" class="addButton">
            <span class="material-icons-sharp">add</span>
          </div>
        </div>
      </div> -->
      <div v-for="(type, index) in formTypes" :key="index">
        <div v-if="!value._id && value.modalType == 'bl'">
          <div class="fileFormOne">
            <div class="input-section">
              <label>Type de conteneur</label>
              <v-autocomplete
                v-model="type.containType"
                :items="conteneurDataTypeNameList"
                rounded
              ></v-autocomplete>
            </div>
            <div class="input-section">
              <label>Quantité</label>
              <input
                type="text"
                v-model="type.totalContainer"
                placeholder="Quantité"
                required
              />
            </div>
          </div>
          <!-- <div class="listeDynamicContent">
            <div v-if="index === formTypes.length - 1">
              <div @click="addIdForConteneurListe()" class="addButton">
                <span class="material-icons-sharp">add</span>
              </div>
            </div>
            <div
              @click="removeIdForConteneurListe(index)"
              class="closeModalButton"
            >
              <span class="material-icons-sharp">remove</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'conteneurPrincipaleAll'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Numéro de facture <span class="required-color">*</span></label>
          <v-autocomplete
            disabled
            class="disabled"
            v-model="manipulateData.contractDetail"
            :items="contratDataDetailsTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Numéro bl <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.bl"
            :items="blDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Désignation <span class="required-color">*</span> </label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.product"
            placeholder="Désignation"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Numéro conteneur <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Numéro conteneur"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Type de Conteneur <span class="required-color">*</span>
          </label>
          <v-autocomplete
            v-model="manipulateData.containType"
            :items="conteneurDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label> Quantité <span class="required-color"> (Tone)</span> </label>
          <input
            type="number"
            v-model="manipulateData.tonsQuantity"
            placeholder="Quantité de produit"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Quantité
            <span class="required-color"> ({{ ProductContentType }})</span>
          </label>
          <input
            type="number"
            v-model="manipulateData.quantity"
            placeholder="Quantité de produit"
            required
          />
        </div>

        <!-- <div class="input-section">
          <label
            >Magasin de destination <span class="required-color">*</span></label
          >
          <v-autocomplete
            v-model="manipulateData.store"
            :items="storeDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Date de sortie <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.outDate"
            placeholder="Date de sortie"
            required
          />
        </div> -->
        <div class="input-section">
          <label> Etd <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.etdPol"
            placeholder="Etdpol"
            required
          />
        </div>
        <div class="input-section">
          <label> ETA <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.eta"
            placeholder="ETA"
            required
          />
        </div>
        <div class="input-section">
          <label> Navire <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.shipName"
            placeholder="Navire"
            required
          />
        </div>
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <!-- <div @click="submitForm" style="margin-left: 30px" class="buttonAdd">
        <span> Enregistrer les modification</span>
      </div> -->

      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'addConteneur'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <!-- <div class="input-section">
          <label>Numéro de facture <span class="required-color">*</span></label>
          <v-autocomplete
    
            v-model="manipulateData.contractDetail"
            :items="contratDataDetailsTypeNameList"
            rounded
          ></v-autocomplete>
        </div> -->

        <div class="input-section">
          <label> Numéro bl <span class="required-color">*</span> </label>

          <v-autocomplete
            v-model="manipulateData.bl"
            @change="checkIfContainer('isAddContainer')"
            :items="blDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label>
            Numéro conteneur <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Numéro conteneur"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Type de Conteneur <span class="required-color">*</span>
          </label>
          <v-autocomplete
            v-model="manipulateData.containType"
            :items="conteneurDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>

        <div class="input-section">
          <label> Quantité <span class="required-color"> (Tone)</span> </label>
          <input
            type="number"
            v-model="manipulateData.tonsQuantity"
            placeholder="Quantité de produit"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Quantité
            <span class="required-color"> ({{ ProductContentType }})</span>
          </label>
          <input
            type="number"
            v-model="manipulateData.quantity"
            placeholder="Quantité de produit"
            required
          />
        </div>

        <!-- <div class="input-section">
          <label
            >Magasin de destination <span class="required-color">*</span></label
          >
          <v-autocomplete
            v-model="manipulateData.store"
            :items="storeDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Date de sortie <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.outDate"
            placeholder="Date de sortie"
            required
          />
        </div> -->

        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <!-- <div @click="submitForm" style="margin-left: 30px" class="buttonAdd">
        <span> Enregistrer les modification</span>
      </div> -->

      <div v-if="!lockAdd" class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
      <div v-else class="alertNotification">
        <span class="material-icons-sharp mr-5"> warning </span>
        <span>{{
          ` Le dernier conteneur du BL est déjà sorti. Le BL est verrouillé et ne peut pas prendre d'autre conteneur.`
        }}</span>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'deleteContainer'"
      @submit.prevent="handleSubmit"
    >
      <div class="alertNotification">
        <span class="material-icons-sharp mr-5"> warning </span>
        <span>{{
          `Êtes-vous sûr de vouloir supprimer le(s) (${this.manipulateData.isSelecteds.length}) conteneur(s) sélectionnés ? Une fois supprimés, ils ne seront plus dans la liste des conteneurs du système et leurs produits associés seront également retirés du compte des BL.`
        }}</span>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Supprimer</span>
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'sendToStock'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Magasin <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.store"
            :items="storeDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <div class="input-section">
          <label> Date d'envoie <span class="required-color">*</span> </label>
          <input
            type="date"
            v-model="manipulateData.outDate"
            placeholder="Date d'envoie"
            required
          />
        </div>
      </div>
      <div class="alertNotification">
        <span class="material-icons-sharp mr-5"> warning </span>
   
          <span>{{
            "Lors de l'envoi d'un produit vers un magasin, nous vous recommandons de procéder à une éventuelle mise à jour du prix de vente, si nécessaire, afin de maintenir une marge bénéficiaire optimale en tout temps."
          }}</span>
    
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre sans modifier</span>
        </div>
        <div @click="handleClick" class="buttonDoneDark">
          <span> Soumettre sans modifier</span>
        </div>
      </div>

    </form>
    <form
      v-if="manipulateData.modalType == 'customer'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <!-- <div class="input-section">
          <label>Type de client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.role"
            :items="typeOfCustomer"
            rounded
          ></v-autocomplete>
        </div> -->
        <div class="input-section">
          <label> Nom complet <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.name"
            placeholder="Nom complet "
            required
          />
        </div>
        <div class="input-section">
          <label> Raison sociale <span class="required-color"></span> </label>
          <input
            type="text"
            v-model="manipulateData.company"
            placeholder="Raison sociale"
            required
          />
        </div>

        <div class="input-section">
          <label> Contact <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.phones"
            placeholder="Contact"
            required
          />
        </div>
        <div class="input-section">
          <label> Email <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.email"
            placeholder="Email"
            required
          />
        </div>
        <div class="input-section">
          <label> Adresse <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.address"
            placeholder="Adresse"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'customerCommande'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Client <span class="required-color">*</span></label>
          <v-autocomplete
            v-model="manipulateData.customer"
            :items="customerListDataTypeNameList"
            rounded
          ></v-autocomplete>
        </div>
        <!-- <div class="input-section">
          <label> Total vente <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder="Total vente"
            required
          />
        </div> -->
        <div class="input-section">
          <label> Observation <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
      <div v-if="manipulateData.customer">
        <span
          v-if="
            manipulateData.modalType == 'customerCommande' &&
            !manipulateData._id
          "
          class="formTitle"
        >
          {{ "Commande détaille" }}
        </span>

        <div
          v-if="
            !manipulateData._id &&
            manipulateData.modalType == 'customerCommande'
          "
          class="listeDynamicContent"
        >
          <div v-if="commandeDettaillesDynamic.length === 0">
            <div @click="addId()" class="addButton">
              <span class="material-icons-sharp">add</span>
              <span> Ajouter produit</span>
            </div>
          </div>
        </div>
        <div v-for="(type, index) in commandeDettaillesDynamic" :key="index">
          <div v-if="!manipulateData._id" class="separation"></div>
          <div
            v-if="
              !manipulateData._id &&
              manipulateData.modalType == 'customerCommande'
            "
          >
            <div class="fileForm">
              <div class="input-section">
                <label>Produit</label>
                <v-autocomplete
                  v-model="type.product"
                  :items="productDataTypeNameList"
                  roundedfindDispo
                  @change="findDispo(index)"
                  @input="findDispo(index)"
                ></v-autocomplete>
              </div>

              <div v-if="type.product" class="input-section">
                <label>Quantité disponible</label>
                <input
                  type="number"
                  disabled
                  class="disabled"
                  v-model="type.totalAvailableQuantity"
                  placeholder="Quantité"
                  required
                />
              </div>
              <div v-if="type.product" class="input-section">
                <label>Prix de vente</label>
                <input
                  type="number"
                  disabled
                  class="disabled"
                  v-model="type.unitPrice"
                  placeholder="Prix de vente"
                  required
                />
              </div>
              <div v-if="type.product" class="input-section">
                <label>Quantité</label>
                <input
                  type="number"
                  @input="calculeTotal()"
                  v-model="type.quantity"
                  placeholder="Quantité"
                  required
                />
              </div>
              <!-- <div
                v-if="!manipulateData._id && type.product"
                class="separation"
              ></div>
              <div v-if="type.product">
                <div v-if="type.quantityByStore.length === 0">
                  <div @click="addIdStore()" class="addButton">
                    <span class="material-icons-sharp">add</span>
                    <span> Ajouter magasin</span>
                  </div>
                </div>
                <div
                  v-for="(element, elementIndex) in type.quantityByStore"
                  :key="elementIndex"
                >
                  <div class="input-section">
                    <label>Magasin de vente</label>
                    <v-autocomplete
                      v-model="element.store"
                      :items="type.storeDispo"
                      rounded
                    ></v-autocomplete>
                  </div>
                  <div class="input-section mt-2">
                    <label>
                      Quantité <span class="required-color">*</span>
                    </label>
                    <input
                      type="number"
                      @input="calculeTotalDétaille(index)"
                      v-model="element.quantity"
                      placeholder="Quantité"
                      required
                    />
                  </div>
                  <div class="listeDynamicContentSecond">
                    <div
                      v-if="elementIndex === type.quantityByStore.length - 1"
                    >
                      <div @click="addIdStore(index)" class="addButton">
                        <span class="material-icons-sharp">add</span>
                      </div>
                    </div>
                    <div
                      @click="removeIdStore(index, elementIndex)"
                      class="closeModalButton"
                    >
                      <span class="material-icons-sharp">remove</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!manipulateData._id && type.product"
                class="separation"
              ></div> -->

              <!-- <div v-if="type.product && type.quantity" class="input-section">
                <label> Bonus de fidelite  <span class="required-color">*</span> </label>
                <input
                  type="number"
                  @input="calculeTotal()"
                  v-model="type.reduction"
                  placeholder="Bonus de fidelite "
                  required
                />
              </div>
              <div v-if="type.product && type.quantity" class="input-section">
                <label>Observation Bonus de fidelite </label>
                <input
                  type="text"
                  v-model="type.observationReduction"
                  placeholder="Observation Bonus de fidelite "
                  required
                />
              </div> -->
            </div>

            <div class="listeDynamicContent">
              <div v-if="index === commandeDettaillesDynamic.length - 1">
                <div @click="addId()" class="addButton">
                  <span class="material-icons-sharp">add</span>
                  <span> Ajouter produit</span>
                </div>
              </div>
              <div @click="removeId(index)" class="closeModalButton">
                <span class="material-icons-sharp">remove</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          (commandeDettaillesDynamic.length > 0 &&
            commandeDettaillesDynamic[0].product) ||
          manipulateData._id
        "
        class="contentButton"
      >
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'detailsStock'"
      class=""
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormSecond">
        <div class="input-section">
          <label>
            Désignation produit <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="manipulateData.product"
            disabled
            class="disabled"
            placeholder="Désignation produit"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de produit <span class="required-color">*</span></label>
          <input
            type="text"
            v-model="manipulateData.productType"
            disabled
            class="disabled"
            placeholder="Type de produit"
            required
          />
        </div>
        <div class="input-section">
          <label> Quantité <span class="required-color">(-)</span> </label>
          <input
            type="text"
            disabled
            class="disabled"
            v-model="manipulateData.quantity"
            placeholder="Quantité"
            required
          />
        </div>
      </div>

      <div
        style="margin-left: 30px; margin-right: 30px; width: calc(100% - 60px)"
        class="contentLists"
      >
        <table class="contentListeTable">
          <thead>
            <tr>
              <th v-for="item in tableHeaderStock" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in soreStockData" :key="item._id">
              <td>
                {{ item.store ? item.store.name : "" }}
              </td>
              <td>
                {{ item.store ? item.store.responsible : "" }}
              </td>
              <td>{{ item.quantity }}</td>
              <td>
                {{
                  item.quantity && item.product
                    ? item.quantity * item.product.unitPrice
                    : 0
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'enterProductInStock'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Quantité estimée <span class="required-color">*</span></label>
          <input
            type="number"
            v-model="manipulateData.quantity"
            placeholder="Quantité estimée"
            required
            disabled
            class="disabled"
          />
        </div>
        <div class="input-section">
          <label
            >Quantité réceptionner
            <span class="required-color"
              >({{ ProductContentType }})</span
            ></label
          >
          <input
            type="number"
            @input="calculePert()"
            v-model="manipulateData.acknowledgeReceiptQuantity"
            placeholder="Quantité réceptionner"
            required
          />
        </div>
        <div class="input-section">
          <label>
            Date de réception <span class="required-color">*</span>
          </label>
          <input
            type="date"
            disabled
            class="disabled"
            v-model="manipulateData.acknowledgeReceiptDate"
            placeholder="Date de réception"
            required
          />
        </div>
        <div
          v-show="
            manipulateData.quantity > manipulateData.acknowledgeReceiptQuantity
          "
          class="input-section"
        >
          <label>
            Quantité déficite <span class="required-color">*</span>
          </label>
          <input
            type="number"
            v-model="manipulateData.perteProducts"
            placeholder="Quantité déficite"
            required
            disabled
            class="disabled"
          />
        </div>
        <div v-show="manipulateData.perteProducts" class="input-section">
          <label>
            Observation déficite <span class="required-color">*</span>
          </label>
          <input
            type="observation"
            v-model="manipulateData.observation"
            placeholder="Observation déficite"
            required
          />
        </div>
      </div>
      <div class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>
    <form
      v-if="manipulateData.modalType == 'stockInventory'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit <span class="required-color">*</span></label>
          <input
            type="text"
            v-model="manipulateData.product"
            placeholder="Produit"
            required
            disabled
            class="disabled"
          />
        </div>
        <div class="input-section">
          <label>Type de produit <span class="required-color">*</span></label>
          <input
            type="text"
            v-model="manipulateData.productType"
            placeholder="Type de produit"
            required
            disabled
            class="disabled"
          />
        </div>
        <div class="input-section">
          <label
            >Quantité actuelle
            <span class="required-color"
              >({{ ProductContentType }})</span
            ></label
          >
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.quantityDispos"
            placeholder="Quantité déficite"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de déficit</label>
          <v-autocomplete
            v-model="manipulateData.isSurPlus"
            :items="deficitType"
            rounded
          ></v-autocomplete>
        </div>
        <div v-if="manipulateData.isSurPlus" class="input-section">
          <label
            >Quantité déficite
            <span class="required-color"
              >({{ ProductContentType }})</span
            ></label
          >
          <input
            type="number"
            v-model="manipulateData.quantity"
            placeholder="Quantité déficite"
            required
          />
        </div>
        <div v-if="manipulateData.isSurPlus" class="input-section">
          <label>
            Fichier de preuve <span class="required-color">*</span>
          </label>
          <input
            type="file"
            multiple
            v-on:change="manipulateData.documents = $event.target.files"
            placeholder="Fichier de preuve"
            required
          />
        </div>
        <div v-if="manipulateData.isSurPlus" class="input-section">
          <label
            >observation déficite <span class="required-color">*</span></label
          >
          <input
            type="text"
            v-model="manipulateData.observation"
            placeholder="observation déficite"
            required
          />
        </div>
      </div>
      <div v-if="manipulateData.isSurPlus" class="contentButton">
        <div @click="submitForm" class="buttonDone">
          <span> Soumettre</span>
        </div>
      </div>
    </form>

    <v-dialog v-model="showExportStatMange" width="750" persistent>
      <v-card>
        <v-card-title class="exportHead">
          {{ excelTypeTitle }}
        </v-card-title>
        <v-card-text>
          <statExport
            :dataJson="dataJsonValue"
            @dataRealOrderChange="updateOrder"
          ></statExport>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="#60174f" text @click="closeExporteModal()">
            Annulé
          </v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn class="buttonDone" @click="exportDataToXls()">
            Exporter le PDF
          </v-btn> -->
          <v-btn class="buttonDone" @click="exportDataToXls()">
            Exporter EXCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import {
  updateProduct,
  addProduct,
  updateSupplier,
  addSupplier,
  addTransitaire,
  updateTransitaire,
  addStore,
  updateStore,
  updateUser,
  addUser,
  updateConteneur,
  addConteneur,
  addContrat,
  updateContrat,
  updateBlDetails,
  addBlDetails,
  updateContaineurAll,
  addContaineurAll,
  postSendConteneurToStore,
  updateCustomer,
  addCustomer,
  postGetConteneurToStore,
  saveStockLost,
  createCard,
  addCartDetails,
  postCustomerPayeToCaisse,
  postMagasiniserOutProductToStock,
  updateCard,
  deleteContaineurAll,
  postCaisseCrediteCustomerBalance,
  magasinAddPerte,
  addMoneyRequest,
  updateMoneyRequest,
  postVideMoneyToUser,
  adminValideComptableDemande,
  adminRejectComptableDemande,
  addCustomerMakeReturnToStoreProduct,
  updateCustomerMakeReturnToStoreProduct,
  magasinValidReturnToStockDemande,
  magasinRejectReturnToStockDemande,
  perteSurInventaireAcceptDemande,
  perteSurInventaireRejectDemande,
  adminMakeReductForCustomer,
  sendToCaisse,
  downloadInserErrorData,
  adminGiveAccord,
  adminRejectAccord,
  deleteProduct,
  deleteSupplier,
  deleteTransitaire,
  deleteStore,
  deleteUser,
  deleteContract,
  deleteConteneur,
  deleteCustomer,
} from "../api/user";

import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "../utils/data";
import statExport from "./statExport.vue";
export default {
  name: "formulaireView",
  props: {
    value: {
      type: Object, // Type de la valeur que vous attendez
      required: true, // Indique que cette prop est requise
    },
  },
  components: {
    statExport,
  },
  data() {
    return {
      filteredItems: [],
      blListeData: [],
      excelTypeTitle: "",
      contratDataTypeNameList: [],
      showListBl: false,
      totalTaxevalue: 0,
      totalOtherTaxevalue: 0,
      latitude: "",
      showExportStatMange: false,
      totalTansitSaveDatavalue: 0,
      realTimeOrder: [],
      dataJsonValue: {
        excelTypeTitle: "",
        data: [],
        order: [],
      },
      clientFormatExporte: {
        title: "",
        excelSubTitle: "",
        totalNumberFields: [],
        data: [],
      },
      longitude: "",
      tableHeaderTransite: ["Désignation", "Montant"],
      tableHeaderTaxe: ["Désignation", "Nombre de jour", "Montant"],
      tableHeaderForCardDetail: [
        "Produit",
        "Type",
        "Prix unitaire",
        "Quantité",
        // "Montant de vente",
        // "Bonus de fidélité",
        "Montant Total",
        "Magasin",
      ],
      tableHeader: [
        "",
        "Produit",
        "N commande",
        "Quantité",
        "Montant FCFA",
        // "Fcl",
        // "Références",
        // "Observations",
      ],
      tableHeaderStock: [
        "Magasin",
        "Responsable",
        "Quantité",
        "Estimation montant",
      ],
      paymentMethodsAdd: ["Espèces", "Chèque", "Virement"],
      paymentMethods: [
        "Portefeuille",
        "Espèces",
        // "À crédit",
        "Chèque",
        "Virement",
      ],
      deficitType: ["Manquant", "Excédent"],
      items: [
        "Carton",
        "Boîte",
        "Emballage",
        "Bundle",
        "Bouteille",
        "Sachet",
        "Sac",
        "Pot",
        "Tube",
        "Aérosol",
        "Bidon",
        "Caisse",
        "Palette",
        "Cageot",
        "Baril",
        "Fût",
        "Seau",
        "Bocal",
        "Canette",
        "Pack",
        "Pochette",
        "Enveloppe",
        "Papier",
        "Plastique",
        "Verre",
        "Métal",
        // Ajoutez d'autres types de produit ici au besoin
      ],
      unitItems: [
        "Pièce",
        "Kilogramme",
        "Gramme",
        "Tonne",
        "Litre",
        "Millilitre",
        "Mètre",
        "Centimètre",
        "Mètre carré",
        "Mètre cube",
        "Mètre linéaire",
        "Pouce",
        "Pied",
        "Yard",
        "Baril",
        "Palette",
        "Caisse",
        "Carton",
        "Boîte",
        "Paquet",
        "Sachet",
        "Bidon",
        "Seau",
        "Bouteille",
        "Papier",
        "Enveloppe",
        "Plateau",
        "Pack",
        "Canette",
        "Pot",
        "Tube",
        // Ajoutez d'autres unités de mesure au besoin
      ],
      manipulateData: null,
      productDataTypeNameList: [],
      formTypes: [
        {
          containType: "",
          totalContainer: 1,
        },
      ],
      showElement: false,
      conteneurItemsDataType: [],
      // roleListe: ["Administrateur", "Magasinier", "Vente", "Prospect"],
      roleListe: [
        "Accueil",
        "Caisse",
        "Responsable des opérations",
        "Responsable financier",
        "Magasinier",
        "Contrôleur",
        "Administrateur",
      ],
      conteneurItems: [
        {
          type: "10 pieds",
          description:
            "Conteneur de petite taille de 10 pieds de longueur, utilisé pour des expéditions de petite envergure.",
        },
        {
          type: "20 pieds",
          description:
            "Conteneur standard de 20 pieds (6,096 mètres) de longueur. utilisé pour le transport de marchandises générales.",
        },

        {
          type: "40 pieds",
          description:
            "Conteneur standard de 40 pieds (12,192 mètres) de longueur. , le plus couramment utilisé dans le transport maritime.",
        },
        {
          type: "High Cube de 40 pieds",
          description:
            "Conteneur de 40 pieds de hauteur supérieure à la normale, offrant un volume de chargement supplémentaire.",
        },

        {
          type: "Open Top de 20 ou 40 pieds",
          description:
            "Conteneur avec un toit amovible pour le chargement de marchandises par le haut.",
        },
        {
          type: "Flat Rack de 20 ou 40 pieds",
          description:
            "Conteneur sans parois latérales fixes, adapté au transport de marchandises volumineuses ou encombrantes.",
        },
        {
          type: "Reefer de 20 ou 40 pieds",
          description:
            "Conteneur équipé d'un système de réfrigération pour le transport de marchandises périssables.",
        },
        {
          type: "Tank de 20 ou 40 pieds",
          description:
            "Conteneur conçu pour transporter des liquides en vrac, équipé d'une citerne spéciale.",
        },
        {
          type: "Plateforme de 20 ou 40 pieds",
          description:
            "Conteneur sans parois latérales, utilisé pour le transport de marchandises lourdes ou de grande taille.",
        },
        {
          type: "45 pieds",
          description:
            "Conteneur de 45 pieds de longueur, utilisé pour le transport de marchandises encombrantes ou volumineuses.",
        },
        {
          type: "53 pieds",
          description:
            "Conteneur de 53 pieds de longueur, souvent utilisé dans le transport terrestre et ferroviaire en Amérique du Nord.",
        },
      ],
      showList: false,
      lockAdd: false,
      showListRole: false,
      unitOfMeasurements: [],
      showListUnit: false,
      showListConteneur: false,
      supplierTypeNameList: [],
      contratDataDetailsTypeNameList: [],
      conteneurDataTypeNameList: [],
      blDataTypeNameList: [],
      userDataTypeNameList: [],
      transitaireDataTypeNameList: [],
      storeDataTypeNameList: [],
      CuntryListe: [],
      customerListDataTypeNameList: [],
      commandeDettaillesDynamic: [
        {
          product: "",
          quantity: 0,
          quantityByStore: [
            {
              store: "",
              quantity: 0,
            },
          ],
          observation: "",
          // store: "",
          unitPrice: 0,
          reduction: 0,
          observationReduction: "",
          storeDispo: [],
          storeSelectId: "",
          totalAvailableQuantity: 0,
        },
      ],
      typeOfTaxeAll: [
        "Valeurs taxées",
        "Totaux déclarations",
        "Montants BFU",
        "Valeurs Douane attestées CFA",
        "Valeurs Douane déclarées CFA",
        "Gardiennages",
        "Surestaries",
        "Stationnements portuaires",
        "Dépôts Douane",
      ],
      itemsBank: [
        "BANQUE INTERNATIONALE POUR L’INDUSTRIE ET LE COMMERCE (BIIC)",
        "BANK Of AFRICA (BOA)",
        "ORABANK BENIN (OBB)",
        "ECOBANK BENIN (EBB)",
        "NSIA BANQUE",
        "MTN MOMO",
        "MOOV FLOOZ",
        "CELTIS CASH",
        "SOCIETE GENERALE du BENIN (SGB)",
        "BANQUE SAHELO-SAHARIENNE POUR L’INVESTISSEMENTEMENT ET LE COMMERCE (BSIC-BENIN)",
        "BANQUE ATLANTIQUE AU BENIN (BAB)",
        "BGFIBANK BENIN",
        "UNITED BANK FOR AFRICA (UBA)",
        "CCEI BANK BENIN Afriland First Group",
        "CBAO BENIN Groupe Attijariwafa Bank",
        "CORIS BANK INTERNATIONAL (CBI)",
        "SOCIÉTÉ NIGÉRIENNE DE BANQUE (SONIBANK)",
      ],
      statTypeListeDataOn: ["Tracking de produit", "Tracking de BL"],
      statTypeListeData: [
        // "Tracking de produit",
        "Historique du prix de vente",
        "Historique du prix de revient (estimations)",
        "Liste des BL",
        "Liste des bons",
        "Liste des bons en attente de paiement",
        "Liste des bons payé",
        "Liste des commandes en attente de livraison",
        "Liste des commandes livrés",
        "Liste des clients",
        "Liste des transaction client",
        "Liste des conteneurs déchargés",
        "Liste des conteneurs non déchargés",
        "Liste des contrats",
        "Liste des factures",
        "Liste des fournisseurs",
        "Liste des magasins",
        "Liste des produits",
        "Coût de revient des ",
        "Estimation du prix de vente produit",
        //"Liste des sorties d'argent",
        //"Liste des stocks complets",
        //"Liste des transitaires",
        //"Liste des transactions caissier",
        //"Liste des transactions client",
        //"Liste Entrées stock magasin",
        //"Liste Sorties stock magasin",
        //"Récapitulatif des produits par ordre de vente",
        //"Récapitulatif du chiffre d'affaires",
      ],
      valueStat: "",
      ProductContentType: "-",
      typeOfCustomer: [
        "Nouveaux clients",
        "Clients réguliers",
        "Clients occasionnels",
        "Clients insatisfaits",
        "Clients potentiels",
        "Clients de gros",
        "Clients B2B (Business to Business)",
        "Clients B2C (Business to Consumer)",
        "Clients internationaux",
      ],
    };
  },
  // created() {
  //   this.manipulateData = this.value;
  // },
  watch: {
    supplierData() {
      this.supplierTypeNameList = defaultMethods.getNameList(this.supplierData);
    },
    contratData() {
      this.contratDataTypeNameList = defaultMethods.getNameList(
        this.contratData
      );
    },
    contratDataDetails() {
      this.contratDataDetailsTypeNameList = defaultMethods.getNameList(
        this.contratDataDetails
      );
    },

    conteneurData() {
      this.conteneurDataTypeNameList = defaultMethods.getNameList(
        this.conteneurData
      );
    },
    blData() {
      this.blDataTypeNameList = defaultMethods.getNameList(this.blData);
    },
    userData() {
      this.userDataTypeNameList = defaultMethods.getNameList(this.userData);
    },
    transitaireData() {
      this.transitaireDataTypeNameList = defaultMethods.getNameList(
        this.transitaireData
      );
    },
    storeData() {
      this.storeDataTypeNameList = defaultMethods.getNameList(this.storeData);
    },
    customerListData() {
      this.customerListDataTypeNameList = defaultMethods.getNameList(
        this.customerListData
      );
    },
    cardDetails() {
      const sommeReductions = this.cardDetails.reduce((acc, current) => {
        return Number(acc) + Number(current.amount);
      }, 0);
      this.manipulateData.amount = sommeReductions;
    },
    productData() {
      // alert('ok')
      this.productDataTypeNameList = defaultMethods.getNameList(
        this.productData
      );
    },
    // taxDataOther(){
    //   this.makeCalculeTotalAmount();
    // },
    taxData() {
      this.makeCalculeTotalAmount();
    },
    value() {
      // alert("ok");
      this.manipulateData = {};
      this.commandeDettaillesDynamic = [
        {
          product: "",
          quantity: 0,
          quantityByStore: [
            {
              store: "",
              quantity: 0,
            },
          ],
          observation: "",
          // store: "",
          unitPrice: 0,
          reduction: 0,
          observationReduction: "",
          storeDispo: [],
          storeSelectId: "",
          totalAvailableQuantity: 0,
        },
      ];
      if (
        this.value.modalType == "conteneurPrincipaleAll" ||
        this.value.modalType == "enterProductInStock"
      ) {
        this.checkProductInfo(this.value.product);
      }
      if (this.value.role) {
        this.checkIfHaveStore(this.value.role);
      }
      if (this.value.valueStat) {
        this.getSelectFilter(this.value.valueStat);
      }
      this.calculeTotal();
      console.log("manipulateData", this.manipulateData);
      console.log("value", this.value);
      this.manipulateData = this.value;

      console.log("manipulateDataend", this.manipulateData);
    },
  },

  computed: {
    ...mapGetters([
      "supplierData",
      "contratDataDetails",
      "contratData",
      "conteneurData",
      "blData",
      "transitaireData",
      "storeData",
      "UserProfile",
      "customerListData",
      "productData",
      "soreStockData",
      "taxData",
      "cardDetails",
      "userData",
      "statLink",
      "statPatch",
      "card",
      "priceHistory",
      "contenuerAllData",
      "customerTransaction",
      "unitePriceEstimationHistory",
      "productBuyEstimation",
      "taxDataOther",
      "tansitSaveData",
      "navireListe",
      "taxData",
      "blCoastEstimation",
    ]),
  },
  async mounted() {
    this.conteneurItemsDataType = defaultMethods.getNameList(
      this.conteneurItems
    );
    this.$getLocation({}).then((coordinates) => {
      // console.log(coordinates);
      this.longitude = coordinates.lng;
      this.latitude = coordinates.lat;
      // alert(JSON.stringify(coordinates));
    });
    this.CuntryListe = defaultMethods.getNameList(
      defaultMethods.getCountryListe()
    );
  },
  methods: {
    ...mapActions([
      "getProduct",
      "getSupplier",
      "getTransitaire",
      "getStore",
      "getUser",
      "getConteneur",
      "getContrat",
      "getBl",
      "getConteneurAll",
      "getCustomerList",
      "getFindProductStockDispo",
      "getCard",
      "getRequestUserTransaction",
      "getUser",
      "getReturnToStock",
      "getMissingInventory",
      "getUserProfile",
      "getCardDetails",
      "getCustomerTransaction",
      "getContratDetails",
      "printBon",
      "printBonMagasin",
      "printBonFacture",
      "getHistoryPrice",
      "getUnitHistoryPrice",
      "getStoreStock",
      "getReductData",
      "getProductPriceBuy",
      "getNavireListe",
      "getUserWalletData",
      "getBlTracking",
      "getTaxStat",
      "getBlCoastEstimation",
    ]),
    // handleSubmit() {
    //   // Émet l'événement 'formSubmitted' et envoie les données du formulaire

    // },
    async sendToCaisseFunction() {
      const isStoreFilledForAllItems = this.cardDetails.every(
        (item) => item.store && Object.keys(item.store).length > 0
      );

      if (isStoreFilledForAllItems) {
        this.$emit("show", true);
        // alert(this.manipulateData._id)alreadyExpired
        await sendToCaisse({ id: this.manipulateData._id });
        await this.getCard({ status: "Attente", alreadyExpired: false });
        this.$emit("closeAllModal");
        this.$emit("show", false);
      } else {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad(
            "Tous les produits doivent être récupérés dans un magasin. Veuillez sélectionner un magasin pour chaque produit."
          )
        );
      }
    },
    async printBonFunction() {
      try {
        this.$emit("show", true);
        // alert(this.manipulateData._id)
        await this.printBon({ id: this.manipulateData._id });
      } catch (error) {
        // Gérer les erreurs ici
        console.error("Une erreur est survenue :", error);
      } finally {
        this.$emit("show", false);
      }
    },

    checkIfHaveStore(item) {
      if (
        item === "Accueil" ||
        item === "Caisse" ||
        item === "Responsable financier" ||
        item === "Manager"
      ) {
        this.showElement = false;
      } else {
        this.showElement = true;
      }
      // alert(this.showElement)
    },
    async findDispo(index) {
      // this.$emit("show", true);
      const product = this.commandeDettaillesDynamic[index].product;

      try {
        // Vérifier si le produit existe déjà à un autre index
        const productExists = this.commandeDettaillesDynamic.some(
          (item, i) => i !== index && item.product === product
        );

        if (productExists) {
          this.$emit("show", false);
          // Si le produit existe déjà à un autre index, afficher une erreur
          defaultMethods.dispatchError(
            this.$store,
            messages.failedToLoad("Le produit existe déjà dans votre liste")
          );
          // Effacer l'élément à l'index donné
          this.commandeDettaillesDynamic.splice(index, 1);
          this.$emit("show", false);
        } else {
          // Sinon, continuer avec la logique d'origine
          const res = await this.getFindProductStockDispo({
            product: defaultMethods.getItemId(
              this.productData,
              this.commandeDettaillesDynamic[index].product
            ),
            // quantity: this.commandeDettaillesDynamic[index].quantity,
          });
          // alert(JSON.stringify(res))
          if (res.data.length > 0) {
            this.commandeDettaillesDynamic[index].totalAvailableQuantity =
              res.totalAvailableQuantity;
            this.commandeDettaillesDynamic[index].unitPrice =
              res.data[0].product.unitPrice;
            this.commandeDettaillesDynamic[index].storeDispo =
              defaultMethods.getNameList(res.data);
            // this.calculeTotal();
            console.log("dynamicContente", this.commandeDettaillesDynamic);
          } else {
            defaultMethods.dispatchError(
              this.$store,
              messages.failedToLoad("Ce produit n'est pas disponible en stock.")
            );
          }
        }
      } catch (error) {
        // Gérer les erreurs
        console.error(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad(
            "Une erreur est survenue lors de la récupération des données"
          )
        );
      } finally {
        this.$emit("show", false);
        console.log(this.commandeDettaillesDynamic);
      }
    },
    cheekSotckMax() {
      if (
        this.manipulateData.quantityLessToRemoved < this.manipulateData.quantity
      ) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad(
            "La quantité retirée ne doit pas être supérieure à la quantité à retirer."
          )
        );
        this.manipulateData.quantity =
          this.manipulateData.quantityLessToRemoved;
      }
    },
    calculeTotal() {
      // Remplacer les valeurs vides par 0

      this.manipulateData.amount = 0;

      for (var i = 0; i < this.commandeDettaillesDynamic.length; i++) {
        // Convertir les valeurs vides en 0
        const unitPrice = this.commandeDettaillesDynamic[i].unitPrice || 0;
        const quantity = this.commandeDettaillesDynamic[i].quantity || 0;
        const reduction = this.commandeDettaillesDynamic[i].reduction || 0;

        // Calculer le montant pour chaque élément de commande
        const amount = Number(unitPrice) * Number(quantity) - Number(reduction);

        // Ajouter le montant calculé au montant total

        this.manipulateData.amount += amount;
      }
      this.$emit("calculeTotal", this.manipulateData.amount);
      // alert(this.manipulateData.amount)
    },
    manipulateDataToSentValueToStat() {
      if (this.manipulateData.valueStat) {
        this.$emit("statEmitValue", this.manipulateData);
      }
      // this.manipulateData.valueStat = this.valueStat
    },
    async duplicateItem(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.contratDataDetails.length; i++) {
          this.contratDataDetails[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratDataDetails);
        await this.getProduct({});
        await this.getConteneur();
        const manipulateData = {
          // _id: item._id,
          contratId: this.manipulateData._id,
          modalType: "contratDuplicateData",
          number: "",
          tonsQuantity: item.tonsQuantity,
          quantity: item.quantity,
          amountInCurrency: item.amountInCurrency,
          currency: item.currency,
          amount: item.amount,
          fcl: item.fcl,
          referenceReservation: item.referenceReservation,
          observation: item.observation,
          product: item.product ? item.product.name : "",
        };
        this.$emit("editeRowForDash", {
          name: "contratDuplicateData",
          size: 300,
          value: manipulateData,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModalForSecond");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewMinusContainer() {
      this.$emit("show", true);
      // await this.getProduct({});
      // await this.getConteneur();
      const value = {
        contratId: this.manipulateData._id,
        modalType: "containerTaxAdd",
        typeOfTaxe: 'Transit',
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "containerTaxAdd",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async editNewMinusContainer(item, name) {
      this.$emit("show", true);
      if (!item.isSelected) {
        if (name == "Transit") {
          for (let i = 0; i < this.tansitSaveData.length; i++) {
            this.tansitSaveData[i].isSelected = false;
          }
          item.isSelected = true;
        } else if (name == "Taxe") {
          for (let i = 0; i < this.taxData.length; i++) {
            this.taxData[i].isSelected = false;
          }
          item.isSelected = true;
        } else {
          for (let i = 0; i < this.taxDataOther.length; i++) {
            this.taxDataOther[i].isSelected = false;
          }
          item.isSelected = true;
        }
        console.log("bl info", item);
        await this.getProduct({});
        await this.getConteneur();
        const manipulateData = {
          _id: item._id,
          contratId: item.bl ? item.bl._id : "",
          typeOfTaxe: name == "Transit" ? "Transit" : "Taxe",
          nameSelect:
            name == "Transit" || name == "Taxe" ? item.name : "Autres ...",
          nameText: name == "Autres ..." ? item.name : "",
          amount: item.amount,
          numberOfDays: item.numberOfDays,
          modalType: "containerTaxAdd",
        };
        this.$emit("editeRowForDash", {
          name: "containerTaxAdd",
          size: 300,
          value: manipulateData,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModalForSecond");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },

    async addNewMinusContrat() {
      this.$emit("show", true);
      await this.getProduct({});
      await this.getConteneur();
      const value = {
        contratId: this.manipulateData._id,
        modalType: "detailsContractCommande",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "detailsContractCommande",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    checkLocation() {
      this.manipulateData.longitude = this.longitude;
      this.manipulateData.latitude = this.latitude;
      // alert(JSON.stringify(this.manipulateData))
    },
    async addNewMinusCart() {
      this.$emit("show", true);
      await this.getCustomerList({});
      await this.getProduct({});
      await this.getStore({});
      const value = {
        cartId: this.manipulateData._id,
        cartReduction: this.manipulateData.reduction,
        cartAmount: this.manipulateData.amount,
        modalType: "detailsCartDetailleCommande",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "detailsCartDetailleCommande",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async editNewMinusCartDetail(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.cardDetails.length; i++) {
          this.cardDetails[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("updateDetailsCartDetailleCommande", item);
        await this.getCustomerList({});
        await this.getProduct({});
        await this.getStore({});
        const res = await this.getFindProductStockDispo({
          product: defaultMethods.getItemId(
            this.productData,
            item.product ? item.product.name : ""
          ),
          // quantity: this.commandeDettaillesDynamic[index].quantity,
        });

        const manipulateData = {
          _id: item._id,
          modalType: "updateDetailsCartDetailleCommande",
          quantity: item.quantity,
          myQuantity: item.quantity,
          totalAvailableQuantity:
            res.data.length > 0 ? res.totalAvailableQuantity : 0,
          amount: item.amount,
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          unitPrice: item.product ? item.product.unitPrice : "",
          cartUseId: item.cart ? item.cart._id : "",
          // product: item.product ? item.product.name : "",
        };
        this.$emit("editeRowForDash", {
          name: "updateDetailsCartDetailleCommande",
          size: 300,
          value: manipulateData,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModalForSecond");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editNewMinusContrat(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.contratDataDetails.length; i++) {
          this.contratDataDetails[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratDataDetails);
        await this.getProduct({});
        await this.getConteneur();
        const manipulateData = {
          _id: item._id,
          contratId: this.manipulateData._id,
          modalType: "detailsContractCommande",
          number: item.number,
          tonsQuantity: item.tonsQuantity,
          quantity: item.quantity,
          amountInCurrency: item.amountInCurrency,
          currency: item.currency,
          amount: item.amount,
          tonsAmount: item.tonsAmount,
          fcl: item.fcl,
          referenceReservation: item.referenceReservation,
          observation: item.observation,
          product: item.product ? item.product.name : "",
        };
        this.$emit("editeRowForDash", {
          name: "detailsContractCommande",
          size: 300,
          value: manipulateData,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModalForSecond");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    selectItemBl(item) {
      this.manipulateData.contract = item;
      this.blListeData = [];
      this.showListBl = false;
    },
    calculePert() {
      this.manipulateData.perteProducts =
        Number(this.manipulateData.quantity) -
        Number(this.manipulateData.acknowledgeReceiptQuantity);
      // alert(this.manipulateData.perteProducts)
    },
    filterBlFunction() {
      this.blListeData = this.contratDataTypeNameList.filter((item) =>
        item.toLowerCase().includes(this.manipulateData.contract.toLowerCase())
      );
    },
    filterOptions() {
      this.filteredItems = this.items.filter((item) =>
        item.toLowerCase().includes(this.manipulateData.type.toLowerCase())
      );
    },
    filterOptionsUnit() {
      this.unitOfMeasurements = this.unitItems.filter((item) =>
        item
          .toLowerCase()
          .includes(this.manipulateData.unitOfMeasurement.toLowerCase())
      );
    },
    calculateReduction(quantityBuy, reduction, quantity) {
      const reductionAmount = (quantityBuy * reduction) / quantity;
      return reductionAmount;
    },
    raccourcirTexte(texte) {
      return texte;
    },
    addIdStore(index) {
      this.commandeDettaillesDynamic[index].quantityByStore.push({
        store: "",
        quantity: 0,
      });
    },
    removeIdStore(index, elementIndex) {
      this.commandeDettaillesDynamic[index].quantityByStore.splice(
        elementIndex,
        1
      ); // Supprimer un seul élément à l'index donné
    },
    calculeTotalDétaille(index) {
      // Remplacer les valeurs vides par 0

      this.commandeDettaillesDynamic[index].quantity = 0;

      for (
        var i = 0;
        i < this.commandeDettaillesDynamic[index].quantityByStore.length;
        i++
      ) {
        // Convertir les valeurs vides en 0
        const quantity =
          this.commandeDettaillesDynamic[index].quantityByStore[i].quantity ||
          0;

        // Ajouter le montant calculé au montant total
        this.commandeDettaillesDynamic[index].quantity += Number(quantity);
      }
      this.calculeTotal();
      // alert(this.manipulateData.amount)
    },
    addId() {
      this.commandeDettaillesDynamic.push({
        product: "",
        quantity: 0,
        quantityByStore: [
          {
            store: "",
            quantity: 0,
          },
        ],
        observation: "",
        // store: "",
        unitPrice: 0,
        reduction: 0,
        observationReduction: "",
        storeDispo: [],
        storeSelectId: "",
        totalAvailableQuantity: 0,
      });
    },

    removeId(index) {
      this.commandeDettaillesDynamic.splice(index, 1); // Supprimer un seul élément à l'index donné
    },
    addIdForConteneurListe() {
      this.formTypes.push({
        containType: "",
        totalContainer: 1,
      });
    },
    getIfShow(item, typeSelect) {
      switch (true) {
        case item === "product" &&
          [
            "Historique du prix de vente",
            "Historique du prix de revient (estimations)",
            "Liste des BL",
            "Liste des conteneurs déchargés",
            "Liste des conteneurs non déchargés",
            "Liste des factures",
            "Liste des retours en stocks",
            "Liste des stocks complets",
            "Liste Entrées stock magasin",
            "Liste Sorties stock magasin",
            "Tracking de produit",
            "Tracking de BL",
            "Estimation du prix de vente produit",
          ].includes(typeSelect):
          return true;
        case item === "Transitaire" && typeSelect === "Liste des BL":
        case item === "Fournisseur" &&
          [
            "Tracking de produit",
            "Tracking de BL",
            "Liste des BL",
            "Liste des contrats",
            "Liste des factures",
          ].includes(typeSelect):
          return true;
        case item === "Client" &&
          [
            "Liste des bons",
            "Liste des bons en attente de paiement",
            "Liste des bons payé",
            "Liste des commandes en attente de livraison",
            "Liste des commandes livrés",
            "Liste des transaction client",
            "Liste des retours en stocks",
            "Liste des transactions client",
          ].includes(typeSelect):
          return true;
        case item === "Magasin" &&
          [
            "Liste des commandes en attente de livraison",
            "Liste des commandes livrés",
            "Liste des retours en stocks",
            "Liste des stocks complets",
            "Liste Entrées stock magasin",
            "Liste Sorties stock magasin",
          ].includes(typeSelect):
          return true;
        case item === "BL" &&
          [
            "Liste des conteneurs déchargés",
            "Liste des conteneurs non déchargés",
          ].includes(typeSelect):
          return true;
        //
        case item === "Taxe" && ["Coût de revient des "].includes(typeSelect):
          return true;
        case item === "Navire" &&
          [
            "Liste des conteneurs déchargés",
            "Liste des conteneurs non déchargés",
          ].includes(typeSelect):
          return true;
        // case item === "Facture" &&
        //   ["Liste des factures"].includes(typeSelect):
        //   return true;
        case item === "Pays" && ["Liste des fournisseurs"].includes(typeSelect):
          return true;
        case item === "Compte" &&
          ["Liste des sorties d'argent"].includes(typeSelect):
          return true;
        case item === "Paiement" &&
          ["Liste des transactions caissier"].includes(typeSelect):
          return true;
        default:
          // Handle other cases if needed
          return false;
      }
    },

    async getSelectFilter(item) {
      if (
        [
          "Historique du prix de vente",
          "Historique du prix de revient (estimations)",
          "Liste des BL",
          "Liste des conteneurs déchargés",
          "Liste des conteneurs non déchargés",
          "Liste des factures",
          "Liste des retours en stocks",
          "Liste des stocks complets",
          "Liste Entrées stock magasin",
          "Liste Sorties stock magasin",
          "Tracking de produit",
          "Tracking de BL",
          "Estimation du prix de vente produit",
        ].includes(item)
      ) {
        await this.getProduct({});
      }

      if (["Liste des BL"].includes(item)) {
        await this.getTransitaire();
      }

      if (
        [
          "Liste des BL",
          "Liste des contrats",
          "Liste des factures",
          "Tracking de produit",
          "Tracking de BL",
        ].includes(item)
      ) {
        await this.getSupplier({});
      }

      if (
        [
          "Liste des bons",
          "Liste des bons en attente de paiement",
          "Liste des bons payé",
          "Liste des commandes en attente de livraison",
          "Liste des commandes livrés",
          "Liste des transaction client",
          "Liste des retours en stocks",
          "Liste des transactions client",
        ].includes(item)
      ) {
        await this.getCustomerList({});
      }

      if (
        [
          "Liste des commandes en attente de livraison",
          "Liste des commandes livrés",
          "Liste des retours en stocks",
          "Liste des stocks complets",
          "Liste Entrées stock magasin",
          "Liste Sorties stock magasin",
        ].includes(item)
      ) {
        await this.getStore({});
      }

      if (
        [
          "Liste des conteneurs déchargés",
          "Liste des conteneurs non déchargés",
          "Coût de revient des ",
        ].includes(item)
      ) {
        await this.getBl({});
        await this.getNavireListe({});
      }

      if (item === "Liste des factures") {
        await this.getContratDetails({});
      }
    },
    getDataEject(item) {
      const dataMap = {
        "Liste des bons": this.card,
        "Liste des bons payé": this.card,
        "Liste des bons en attente de paiement": this.card,
        "Historique du prix de vente": this.priceHistory,
        "Tracking de produit": this.productBuyEstimation,
        "Tracking de BL": this.productBuyEstimation,
        "Coût de revient des ": this.taxData.data,
        "Estimation du prix de vente produit": this.blCoastEstimation,
        "Historique du prix de revient (estimations)":
          this.unitePriceEstimationHistory,
        "Liste des produits": this.productData,
        "Liste des magasins": this.storeData,
        "Liste des contrats": this.contratData,
        "Liste des BL": this.blData,
        "Liste des fournisseurs": this.supplierData,
        "Liste des conteneurs déchargés": this.contenuerAllData,
        "Liste des conteneurs non déchargés": this.contenuerAllData,
        "Liste des factures": this.contratDataDetails,
        "Liste des transaction client": this.customerTransaction,
        "Liste des clients": this.customerListData,
        "Liste des commandes en attente de livraison": this.cardDetails,
        "Liste des commandes livrés": this.cardDetails,
        "Liste des retours en stocks": this.returnStockData,
        "Liste des sorties d'argent": this.requestusertransactionData,
        "Liste des stocks complets": this.globaleStockData,
        "Liste des transitaires": this.transitaireData,
        // "Liste des transactions caissier":
        "Liste Entrées stock magasin": this.contenuerAllData,
        "Liste Sorties stock magasin": this.cardDetails,
        // "Récapitulatif des produits par ordre de vente":
        // "Récapitulatif du chiffre d'affaires":
      };

      return dataMap[item];
    },
    checkIfContainer(item) {
      this.lockAdd = false;
      if (item == "isAddContainer") {
        const itemAllInfo = defaultMethods.getItemInfo(
          this.blData,
          this.manipulateData.bl
        );
        // alert(JSON.stringify(itemAllInfo))
        if (itemAllInfo.isLock) {
          this.lockAdd = true;
        }
      }
    },
    getOrderEject(item) {
      const dataMap = {
        "Liste des bons": [
          {
            name: "Client",
            contentKey: "customer.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Société",
            contentKey: "customer.company",
            order: 1,
            fixed: false,
          },
          {
            name: "Téléphone",
            contentKey: "customer.phones",
            order: 2,
            fixed: false,
          },
          {
            name: "Numéro bon",
            contentKey: "number",
            order: 3,
            fixed: false,
          },
          {
            name: "Date d'expiration bon",
            contentKey: "expiredAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer par",
            contentKey: "createdBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer le",
            contentKey: "createdAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier par",
            contentKey: "updatedBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier le",
            contentKey: "updatedAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Statut",
            contentKey: "status",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant Total",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Nombre de contenue",
            contentKey: "totalCartDetail",
            order: 4,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des bons payé": [
          {
            name: "Client",
            contentKey: "customer.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Société",
            contentKey: "customer.company",
            order: 1,
            fixed: false,
          },
          {
            name: "Téléphone",
            contentKey: "customer.phones",
            order: 2,
            fixed: false,
          },
          {
            name: "Numéro bon",
            contentKey: "number",
            order: 3,
            fixed: false,
          },
          {
            name: "Date d'expiration bon",
            contentKey: "expiredAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer par",
            contentKey: "createdBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer le",
            contentKey: "createdAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier par",
            contentKey: "updatedBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier le",
            contentKey: "updatedAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Statut",
            contentKey: "status",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant Total",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Nombre de contenue",
            contentKey: "totalCartDetail",
            order: 4,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des bons en attente de paiement": [
          {
            name: "Client",
            contentKey: "customer.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Société",
            contentKey: "customer.company",
            order: 1,
            fixed: false,
          },
          {
            name: "Téléphone",
            contentKey: "customer.phones",
            order: 2,
            fixed: false,
          },
          {
            name: "Numéro bon",
            contentKey: "number",
            order: 3,
            fixed: false,
          },
          {
            name: "Date d'expiration bon",
            contentKey: "expiredAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer par",
            contentKey: "createdBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Créer le",
            contentKey: "createdAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier par",
            contentKey: "updatedBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Modifier le",
            contentKey: "updatedAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Statut",
            contentKey: "status",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant Total",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Nombre de contenue",
            contentKey: "totalCartDetail",
            order: 4,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Historique du prix de revient (estimations)": [
          {
            name: "Bl",
            contentKey: "bl.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Produit",
            contentKey: "product.name",
            order: 1,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "product.type",
            order: 2,
            fixed: false,
          },
          {
            name: "Prix actuel",
            contentKey: "product.unitPrice",
            order: 3,
            fixed: false,
          },
          {
            name: "prix de revient",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "product.observation",
            order: 5,
            fixed: false,
          },
        ],
        "Tracking de produit": [
          {
            name: "Total conteneur",
            contentKey: "totalContainer",
            order: 0,
            fixed: false,
          },
          {
            name: "Quantité en tonne",
            contentKey: "tonsQuantity",
            order: 1,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 2,
            fixed: false,
          },
          {
            name: "Montant FCFA",
            contentKey: "cfaAmount",
            order: 3,
            fixed: false,
          },
          {
            name: "Mois d'arrivée",
            contentKey: "etdMonth",
            order: 4,
            fixed: false,
          },
        ],
        "Historique du prix de vente": [
          {
            name: "Date de modification",
            contentKey: "updatedAt",
            order: 0,
            fixed: false,
          },
          {
            name: "Produit",
            contentKey: "product.name",
            order: 1,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "product.type",
            order: 2,
            fixed: false,
          },
          {
            name: "Prix actuel",
            contentKey: "product.unitPrice",
            order: 3,
            fixed: false,
          },
          {
            name: "Prix historique",
            contentKey: "price",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des produits": [
          {
            name: "Désignation",
            contentKey: "name",
            order: 0,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "type",
            order: 1,
            fixed: false,
          },
          {
            name: "Unité de messure",
            contentKey: "unitOfMeasurement",
            order: 2,
            fixed: false,
          },
          {
            name: "Prix unitaire",
            contentKey: "unitPrice",
            order: 3,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des magasins": [
          {
            name: "Désignation",
            contentKey: "name",
            order: 0,
            fixed: false,
          },
          {
            name: "Adresse",
            contentKey: "address",
            order: 1,
            fixed: false,
          },
          {
            name: "Responsable magasin",
            contentKey: "storeResponsible.fullName",
            order: 2,
            fixed: false,
          },
          {
            name: "Responsable magasin téléphone",
            contentKey: "storeResponsible.phone",
            order: 3,
            fixed: false,
          },
          {
            name: "Coordonné longitude",
            contentKey: "longitude",
            order: 4,
            fixed: false,
          },
          {
            name: "Coordonné latitude",
            contentKey: "latitude",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des contrats": [
          {
            name: "Date de mise en place",
            contentKey: "createddAt",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro contrat",
            contentKey: "number",
            order: 1,
            fixed: false,
          },
          {
            name: "Fournisseur",
            contentKey: "supplier.fullName",
            order: 2,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 3,
            fixed: false,
          },
        ],
        "Liste des BL": [
          {
            name: "Facture",
            contentKey: "contractDetail.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro BL",
            contentKey: "number",
            order: 1,
            fixed: false,
          },
          {
            name: "Port de chargement",
            contentKey: "loadingPort",
            order: 2,
            fixed: false,
          },
          {
            name: "Navire",
            contentKey: "shipName",
            order: 3,
            fixed: false,
          },
          {
            name: "Ligne",
            contentKey: "lineName",
            order: 4,
            fixed: false,
          },
          {
            name: "Destination",
            contentKey: "destination",
            order: 4,
            fixed: false,
          },
          {
            name: "Etd",
            contentKey: "etdPol",
            order: 4,
            fixed: false,
          },
          {
            name: "ETA",
            contentKey: "eta",
            order: 4,
            fixed: false,
          },
          {
            name: "Transitaire",
            contentKey: "transitaire.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant sur-taxe",
            contentKey: "taxAmount",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant transitaire",
            contentKey: "transitaireAmount",
            order: 4,
            fixed: false,
          },
          {
            name: "Nombre total de conteneur",
            contentKey: "totalContainer",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant de sortie",
            contentKey: "outTotalAmount",
            order: 4,
            fixed: false,
          },
          {
            name: "Délaie d'exécution contrat",
            contentKey: "contractExecutionDelay",
            order: 4,
            fixed: false,
          },
          {
            name: "coût Bl",
            contentKey: "blCoastPrice.amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Prix unitaire par produit",
            contentKey: "unitCoastPrice.amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des fournisseurs": [
          {
            name: "Nom / Raison sociale",
            contentKey: "fullName",
            order: 0,
            fixed: false,
          },
          {
            name: "Téléphone",
            contentKey: "phones",
            order: 1,
            fixed: false,
          },
          {
            name: "Email",
            contentKey: "email",
            order: 2,
            fixed: false,
          },
          {
            name: "Pays de résidence",
            contentKey: "country",
            order: 3,
            fixed: false,
          },
          {
            name: "Correspondant",
            contentKey: "personContactName",
            order: 4,
            fixed: false,
          },
          {
            name: "Téléphone correspondant",
            contentKey: "personContactPhone",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des conteneurs déchargés": [
          {
            name: "Facture",
            contentKey: "contractDetail.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro bl",
            contentKey: "bl.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro conteneur",
            contentKey: "name",
            order: 1,
            fixed: false,
          },
          {
            name: "Type de Conteneur",
            contentKey: "containType.name",
            order: 2,
            fixed: false,
          },
          {
            name: "Description type de Conteneur",
            contentKey: "containType.description",
            order: 2,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 3,
            fixed: false,
          },
          {
            name: "Quantité par contenant",
            contentKey: "tonsQuantity",
            order: 4,
            fixed: false,
          },
          {
            name: "Magasin de livraison",
            contentKey: "store.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Date déchargement",
            contentKey: "acknowledgeReceiptDate",
            order: 0,
            fixed: false,
          },
          {
            name: "Quantité déchargée",
            contentKey: "acknowledgeReceiptQuantity",
            order: 0,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Coût de revient des ": [
          {
            name: "Numéro BL",
            contentKey: "bl.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Transitaire",
            contentKey: "bl.transitaire.name",
            order: 0,
            fixed: false,
          },
          {
            name: "eta",
            contentKey: "bl.eta",
            order: 1,
            fixed: false,
          },
          {
            name: "Nature",
            contentKey: "nature",
            order: 2,
            fixed: false,
          },
          {
            name: "Désignation",
            contentKey: "name",
            order: 2,
            fixed: false,
          },
          {
            name: "Nombre de jours",
            contentKey: "numberOfDays",
            order: 2,
            fixed: false,
          },
          {
            name: "Montant",
            contentKey: "amount",
            order: 2,
            fixed: false,
          },
        ],
        "Estimation du prix de vente produit": [
          // {
          //   name: "Fournisseur",
          //   contentKey: "supplier",
          //   order: 0,
          //   fixed: false,
          // },
          {
            name: "Nombre de conteneur",
            contentKey: "totalContainer",
            order: 0,
            fixed: false,
          },
          {
            name: "Quantité en tonne",
            contentKey: "tonsQuantity",
            order: 0,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 0,
            fixed: false,
          },
          {
            name: "Montant CFA",
            contentKey: "cfaAmount",
            order: 0,
            fixed: false,
          },
          {
            name: "Mois ETD",
            contentKey: "etdMonth",
            order: 0,
            fixed: false,
          },
        ],
        "Liste des conteneurs non déchargés": [
          {
            name: "Facture",
            contentKey: "contractDetail.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro bl",
            contentKey: "bl.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro conteneur",
            contentKey: "name",
            order: 1,
            fixed: false,
          },
          {
            name: "Type de Conteneur",
            contentKey: "containType.name",
            order: 2,
            fixed: false,
          },
          {
            name: "Description type de Conteneur",
            contentKey: "containType.description",
            order: 2,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 3,
            fixed: false,
          },
          {
            name: "Quantité par contenant",
            contentKey: "tonsQuantity",
            order: 4,
            fixed: false,
          },
          {
            name: "Magasin de livraison",
            contentKey: "store.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Date déchargement",
            contentKey: "acknowledgeReceiptDate",
            order: 0,
            fixed: false,
          },
          {
            name: "Quantité déchargée",
            contentKey: "acknowledgeReceiptQuantity",
            order: 0,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des factures": [
          {
            name: "Date de mise en place",
            contentKey: "createddAt",
            order: 0,
            fixed: false,
          },
          {
            name: "Numéro Facture",
            contentKey: "number",
            order: 1,
            fixed: false,
          },
          {
            name: "produit",
            contentKey: "product.name",
            order: 2,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "product.type",
            order: 2,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 2,
            fixed: false,
          },
          {
            name: "Quantité en mesure",
            contentKey: "tonsQuantity",
            order: 2,
            fixed: false,
          },
          {
            name: "Montant de vente Devise",
            contentKey: "amountInCurrency",
            order: 2,
            fixed: false,
          },
          {
            name: "Devise",
            contentKey: "currency",
            order: 2,
            fixed: false,
          },
          {
            name: "Montant de vente Fcfa",
            contentKey: "amount",
            order: 2,
            fixed: false,
          },
          {
            name: "Observation",
            contentKey: "observation",
            order: 3,
            fixed: false,
          },
        ],
        "Liste des transaction client": [
          {
            name: "Nom complet",
            contentKey: "customer.name",
            order: 0,
            fixed: false,
          },
          {
            name: "Société",
            contentKey: "customer.company",
            order: 1,
            fixed: false,
          },

          {
            name: "Téléphone",
            contentKey: "customer.phones",
            order: 4,
            fixed: false,
          },
          {
            name: "Date transaction",
            contentKey: "updatedAt",
            order: 4,
            fixed: false,
          },
          {
            name: "Transaction éffectuer par",
            contentKey: "updatedBy.fullName",
            order: 4,
            fixed: false,
          },
          {
            name: "Motif de transaction",
            contentKey: "name",
            order: 4,
            fixed: false,
          },
          {
            name: "Type de transaction",
            contentKey: "type",
            order: 4,
            fixed: false,
          },
          {
            name: "Mode de paiement",
            contentKey: "paymentMethod",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant transaction",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Statut",
            contentKey: "status",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des clients": [
          {
            name: "Nom complet",
            contentKey: "name",
            order: 0,
            fixed: false,
          },
          {
            name: "Société",
            contentKey: "company",
            order: 1,
            fixed: false,
          },
          {
            name: "Adresse",
            contentKey: "address",
            order: 2,
            fixed: false,
          },
          {
            name: "Mail",
            contentKey: "email",
            order: 3,
            fixed: false,
          },
          {
            name: "Téléphone",
            contentKey: "phones",
            order: 4,
            fixed: false,
          },
          {
            name: "Solde portefeuille",
            contentKey: "wallet.balance",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des commandes en attente de livraison": [
          {
            name: "Numéro de bon",
            contentKey: "cart.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Statut de bon",
            contentKey: "cart.status",
            order: 1,
            fixed: false,
          },
          {
            name: "Client",
            contentKey: "cart.customer.name",
            order: 2,
            fixed: false,
          },
          {
            name: "produit",
            contentKey: "product.name",
            order: 3,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "product.type",
            order: 4,
            fixed: false,
          },
          {
            name: "prix unitaire",
            contentKey: "product.unitPrice",
            order: 4,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant total",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Magasin",
            contentKey: "store.name",
            order: 4,
            fixed: false,
          },
          {
            name: "Produit total retiré",
            contentKey: "quantityRemoved",
            order: 4,
            fixed: false,
          },
          {
            name: "Produit restant à retirer",
            contentKey: "quantityLessToRemoved",
            order: 4,
            fixed: false,
          },
        ],
        "Liste des commandes livrés": [
          {
            name: "Numéro de bon",
            contentKey: "cart.number",
            order: 0,
            fixed: false,
          },
          {
            name: "Statut de bon",
            contentKey: "cart.status",
            order: 1,
            fixed: false,
          },
          {
            name: "Client",
            contentKey: "cart.customer.name",
            order: 2,
            fixed: false,
          },
          {
            name: "produit",
            contentKey: "product.name",
            order: 3,
            fixed: false,
          },
          {
            name: "Type de produit",
            contentKey: "product.type",
            order: 4,
            fixed: false,
          },
          {
            name: "prix unitaire",
            contentKey: "product.unitPrice",
            order: 4,
            fixed: false,
          },
          {
            name: "Quantité",
            contentKey: "quantity",
            order: 4,
            fixed: false,
          },
          {
            name: "Montant total",
            contentKey: "amount",
            order: 4,
            fixed: false,
          },
          {
            name: "Magasin",
            contentKey: "store.name",
            order: 4,
            fixed: false,
          },
          {
            name: "Produit total retiré",
            contentKey: "quantityRemoved",
            order: 4,
            fixed: false,
          },
          {
            name: "Produit restant à retirer",
            contentKey: "quantityLessToRemoved",
            order: 4,
            fixed: false,
          },
        ],
      };
      return dataMap[item];
    },
    closeExporteModal() {
      this.dataJsonValue = Object.assign({});
      this.excelTypeTitle = "";
      this.showExportStatMange = false;
    },
    makeExportPDF(item) {
      this.loading = true; // Start loading
      try {
        // alert(item)
        // Attempt to open the PDF in a new tab
        window.open(item, "_blank");
      } catch (error) {
        // Handle any errors that occur during the attempt
        console.error("Failed to open the PDF:", error);
      } finally {
        // Ensure loading state is stopped regardless of success or failure
        this.loading = false;
      }
    },
    makeExport() {
      console.log("-------My value -------", this.dataJsonValue);
      this.excelTypeTitle = this.manipulateData.valueStat
        ? this.manipulateData.valueStat
        : "Statistique" + " du " + this.manipulateData.startDate
        ? this.manipulateData.startDate
        : "--/--/---" + " au " + this.manipulateData.endDate
        ? this.manipulateData.endDate
        : "--/--/---";

      this.dataJsonValue = Object.assign(
        {},
        {
          excelTypeTitle: this.excelTypeTitle,
          order: this.getOrderEject(this.manipulateData.valueStat),
        }
      );
      console.log("-------My value after all -------", this.dataJsonValue);

      // this.$forceUpdate();
      this.showExportStatMange = true;
    },
    generateFinalData(data, volonteData) {
      // Trier les spécifications par ordre
      // alert(JSON.stringify(data))
      volonteData.sort((a, b) => a.order - b.order);

      const finalData = [];

      data.forEach((item) => {
        const newItem = {};

        volonteData.forEach((spec) => {
          const contentKeyArr = spec.contentKey.split(".");
          let value = item;
          contentKeyArr.forEach((key) => {
            value = value[key];
          });
          newItem[spec.name] = value;
        });

        finalData.push(newItem);
      });

      return finalData;
    },

    updateOrder(item) {
      this.realTimeOrder = item;
      // console.log('orderUpdate', this.realTimeOrder)
    },
    async exportDataToXls() {
      try {
        this.$emit("show", true);
        const valueToExport = this.generateFinalData(
          this.getDataEject(this.manipulateData.valueStat),
          this.realTimeOrder
        );
        this.clientFormatExporte.title = this.excelTypeTitle;
        this.clientFormatExporte.data = valueToExport;
        if (this.clientFormatExporte.data.length > 0) {
          await downloadInserErrorData({ schema: this.clientFormatExporte });
        }
      } catch (error) {
        console.error("Error occurred during export:", error);
        // Vous pouvez gérer l'erreur ici (par exemple, afficher un message à l'utilisateur)
      } finally {
        this.$emit("show", false);
      }
    },
    removeIdForConteneurListe(index) {
      this.formTypes.splice(index, 1); // Supprimer un seul élément à l'index donné
    },
    selectItem(item) {
      this.manipulateData.type = item;
      this.filteredItems = [];
      this.showList = false;
    },
    selectItemUnit(item) {
      this.manipulateData.unitOfMeasurement = item;
      this.unitOfMeasurements = [];
      this.showListUnit = false;
    },
    selectItemRoles(item) {
      this.manipulateData.role = item;
      this.filterOptionsUser = [];
      this.showListRole = false;
    },
    selectItemConteneur(item) {
      this.manipulateData.name = item.type;
      this.manipulateData.description = item.description; // Ajout de la description
      this.conteneurListe = [];
      this.showListConteneur = false;
    },
    selectItemSupplier(item) {
      this.manipulateData.supplier = item;
      this.supplierListeData = [];
      this.showListSupplier = false;
    },
    filterSupplierFunction() {
      this.supplierListeData = this.supplierTypeNameList.filter((item) =>
        item.toLowerCase().includes(this.manipulateData.supplier.toLowerCase())
      );
    },
    filterOptionsFunction() {
      this.filterOptionsUser = this.roleListe.filter((item) =>
        item.toLowerCase().includes(this.manipulateData.role.toLowerCase())
      );
    },
    filterOptionsConteneurFunction() {
      this.conteneurListe = this.conteneurItems.filter((item) =>
        item.type.toLowerCase().includes(this.manipulateData.name.toLowerCase())
      );
    },
    makeNewFilters() {
      var valueFind = this.conteneurItems.filter(
        (item) => item.type == this.manipulateData.name
      );
      // console.log(valueFind)
      this.manipulateData.description = valueFind[0].description;
    },
    checkProductInfo(item) {
      const productInfo = defaultMethods.getItemInfo(this.productData, item);
      // alert(JSON.stringify(this.productData))
      this.ProductContentType = productInfo.type;
    },
    makeCalculeTotalAmount() {
      this.$emit("show", true);
      this.totalTansitSaveDatavalue = 0;
      this.totalTaxevalue = 0;
      this.totalOtherTaxevalue = 0;
      for (let i = 0; i < this.tansitSaveData.length; i++) {
        this.totalTansitSaveDatavalue += Number(this.tansitSaveData[i].amount);
      }
      for (let i = 0; i < this.taxData.length; i++) {
        this.totalTaxevalue += Number(this.taxData[i].amount);
      }
      for (let i = 0; i < this.taxDataOther.length; i++) {
        this.totalOtherTaxevalue += Number(this.taxDataOther[i].amount);
      }
      this.$emit("show", false);
    },
    async submitForm() {
      this.$emit("show", true);
      // alert(this.manipulateData.modalType)
      try {
        console.log(
          "Bloc try : tentative d'exécution du code susceptible de générer une exception."
        );
        if (this.manipulateData.modalType == "product") {
          const schema = {
            name: this.manipulateData.name,
            type: this.manipulateData.type,
            unitOfMeasurement: this.manipulateData.unitOfMeasurement,
            unitPrice: this.manipulateData.unitPrice
              ? this.manipulateData.unitPrice
              : 0,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateProduct({
              schema,
              id: this.manipulateData._id,
            });
            await this.getProduct({});
            this.$emit("closeAllModal");
          } else {
            await addProduct({
              schema,
            });
            await this.getProduct({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "delete") {
          if (this.manipulateData.elementToDelete == "product") {
            if (this.manipulateData._id) {
              await deleteProduct({
                id: this.manipulateData._id,
              });
              await this.getProduct({});
            }
          } else if (this.manipulateData.elementToDelete == "supplier") {
            if (this.manipulateData._id) {
              await deleteSupplier({
                id: this.manipulateData._id,
              });
              await this.getSupplier({});
            }
          } else if (this.manipulateData.elementToDelete == "transitaire") {
            if (this.manipulateData._id) {
              await deleteTransitaire({
                id: this.manipulateData._id,
              });
              await this.getTransitaire({});
            }
          } else if (this.manipulateData.elementToDelete == "store") {
            if (this.manipulateData._id) {
              await deleteStore({
                id: this.manipulateData._id,
              });
              await this.getStore({});
            }
          } else if (this.manipulateData.elementToDelete == "user") {
            if (this.manipulateData._id) {
              await deleteUser({
                id: this.manipulateData._id,
              });
              await this.getUser({});
            }
          } else if (this.manipulateData.elementToDelete == "conteneur") {
            if (this.manipulateData._id) {
              await deleteConteneur({
                id: this.manipulateData._id,
              });
              await this.getConteneur({});
            }
          } else if (this.manipulateData.elementToDelete == "customer") {
            if (this.manipulateData._id) {
              await deleteCustomer({
                id: this.manipulateData._id,
              });
              await this.getCustomerList({});
            }
          } else if (this.manipulateData.elementToDelete == "contract") {
            if (this.manipulateData._id) {
              await deleteContract({
                id: this.manipulateData._id,
              });
              await this.getContract({});
            }
          }
        } else if (this.manipulateData.modalType == "editeReturnStockRow") {
          const schema = {
            product: defaultMethods.getItemId(
              this.productData,
              this.manipulateData.product
            ),
            quantity: this.manipulateData.quantity,
            store: defaultMethods.getItemId(
              this.storeData,
              this.manipulateData.store
            ),
            customer: defaultMethods.getItemId(
              this.customerListData,
              this.manipulateData.customer
            ),
            amount: this.manipulateData.amount,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateCustomerMakeReturnToStoreProduct({
              schema,
              id: this.manipulateData._id,
            });
            await this.getReturnToStock({});
            this.$emit("closeAllModal");
          } else {
            await addCustomerMakeReturnToStoreProduct({
              schema,
            });
            await this.getReturnToStock({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "makeStartParams") {
          this.manipulateDataToSentValueToStat();
          if (this.manipulateData.valueStat === "Historique du prix de vente") {
            await this.getHistoryPrice({
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (
            this.manipulateData.valueStat ===
            "Historique du prix de revient (estimations)"
          ) {
            await this.getUnitHistoryPrice({
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (this.manipulateData.valueStat === "Liste des BL") {
            // Ajoutez votre logique pour 'Liste des BL'
            await this.getBl({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
            });
          } else if (this.manipulateData.valueStat === "Liste des bons") {
            // Ajoutez votre logique pour 'Liste des bons'
            await this.getCard({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (
            this.manipulateData.valueStat ===
            "Liste des bons en attente de paiement"
          ) {
            // Ajoutez votre logique pour 'Liste des bons en attente de paiement'
            await this.getCard({
              status: "Attente",
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              alreadyExpired: false,
            });
          } else if (this.manipulateData.valueStat === "Liste des bons payé") {
            // Ajoutez votre logique pour 'Liste des bons en attente de paiement'
            await this.getCard({
              status: "Acheté",
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (
            this.manipulateData.valueStat ===
            "Liste des commandes en attente de livraison"
          ) {
            // Ajoutez votre logique pour 'Liste des bons en attente de livraison'
            await this.getCardDetails({
              status: "Acheté",
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (
            this.manipulateData.valueStat === "Liste des commandes livrés"
          ) {
            // Ajoutez votre logique pour 'Liste des bons livrés'
            await this.getCardDetails({
              status: "Retiré",
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
          } else if (this.manipulateData.valueStat === "Liste des clients") {
            await this.getCustomerList({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des clients'
          } else if (
            this.manipulateData.valueStat === "Liste des transaction client"
          ) {
            await this.getCustomerTransaction({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });

            // Ajoutez votre logique pour 'Liste des transaction client'
          } else if (
            this.manipulateData.valueStat ===
            "Estimation du prix de vente produit"
          ) {
            await this.getBlCoastEstimation({
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des conteneurs déchargés'
          } else if (this.manipulateData.valueStat === "Coût de revient des ") {
            await this.getTaxStat({
              nature: this.manipulateData.typeOfTaxeAll,
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des conteneurs déchargés'
          } else if (
            this.manipulateData.valueStat === "Liste des conteneurs déchargés"
          ) {
            await this.getConteneurAll({
              alreadyInStock: "Oui",
              haveAcknowledgeReceiptDate: "Oui",
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              bl: defaultMethods.getItemId(this.blData, this.manipulateData.bl),
              shipName: this.manipulateData.shipName,
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des conteneurs déchargés'
          } else if (
            this.manipulateData.valueStat ===
            "Liste des conteneurs non déchargés"
          ) {
            await this.getConteneurAll({
              alreadyInStock: "Oui",
              haveAcknowledgeReceiptDate: "Non",
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              bl: defaultMethods.getItemId(this.blData, this.manipulateData.bl),
              shipName: this.manipulateData.shipName,
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des conteneurs non déchargés'
          } else if (this.manipulateData.valueStat === "Liste des contrats") {
            await this.getContrat({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des contrats'
          } else if (this.manipulateData.valueStat === "Liste des factures") {
            await this.getContratDetails({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              supplier: defaultMethods.getItemId(
                this.supplierData,
                this.manipulateData.supplier
              ),
            });
            // Ajoutez votre logique pour 'Liste des factures'
          } else if (this.manipulateData.valueStat === "Tracking de produit") {
            await this.getProductPriceBuy({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              supplier: defaultMethods.getItemId(
                this.supplierData,
                this.manipulateData.supplier
              ),
            });
            // Ajoutez votre logique pour 'Liste des factures'
          } else if (this.manipulateData.valueStat === "Tracking de BL") {
            await this.getBlTracking({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
              supplier: defaultMethods.getItemId(
                this.supplierData,
                this.manipulateData.supplier
              ),
            });
            // Ajoutez votre logique pour 'Liste des factures'
          } else if (
            this.manipulateData.valueStat === "Liste des fournisseurs"
          ) {
            await this.getSupplier({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des fournisseurs'
          } else if (this.manipulateData.valueStat === "Liste des magasins") {
            await this.getStore({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des magasins'
          } else if (this.manipulateData.valueStat === "Liste des produits") {
            await this.getProduct({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
            });
            // Ajoutez votre logique pour 'Liste des produits'
          } else if (
            this.manipulateData.valueStat === "Liste des retours en stocks"
          ) {
            await this.getReturnToStock({
              startDate: this.manipulateData.startDate,
              endDate: this.manipulateData.endDate,
              product: defaultMethods.getItemId(
                this.productData,
                this.manipulateData.product
              ),
            });
            // Ajoutez votre logique pour 'Liste des retours en stocks'
          } else if (
            this.manipulateData.valueStat === "Liste des retours magasin"
          ) {
            // Ajoutez votre logique pour 'Liste des retours magasin'
          } else if (
            this.manipulateData.valueStat === "Liste des sorties d'argent"
          ) {
            // Ajoutez votre logique pour 'Liste des sorties d\'argent'
          } else if (
            this.manipulateData.valueStat === "Liste des stocks complets"
          ) {
            // Ajoutez votre logique pour 'Liste des stocks complets'
          } else if (
            this.manipulateData.valueStat === "Liste des transitaires"
          ) {
            // Ajoutez votre logique pour 'Liste des transitaires'
          } else if (
            this.manipulateData.valueStat === "Liste des transactions caissier"
          ) {
            // Ajoutez votre logique pour 'Liste des transactions caissier'
          } else if (
            this.manipulateData.valueStat === "Liste des transactions client"
          ) {
            // Ajoutez votre logique pour 'Liste des transactions client'
          } else if (
            this.manipulateData.valueStat === "Liste Entrées stock magasin"
          ) {
            // Ajoutez votre logique pour 'Liste Entrées stock magasin'
          } else if (
            this.manipulateData.valueStat === "Liste Sorties stock magasin"
          ) {
            // Ajoutez votre logique pour 'Liste Sorties stock magasin'
          } else if (
            this.manipulateData.valueStat ===
            "Récapitulatif des produits par ordre de vente"
          ) {
            // Ajoutez votre logique pour 'Récapitulatif des produits par ordre de vente'
          } else if (
            this.manipulateData.valueStat ===
            "Récapitulatif du chiffre d'affaires"
          ) {
            // Ajoutez votre logique pour 'Récapitulatif du chiffre d\'affaires'
          }
        } else if (this.manipulateData.modalType == "moneyRequest") {
          const schema = {
            label: this.manipulateData.label,
            amount: this.manipulateData.amount,
            type: "Sortie",
            paymentMethod: this.manipulateData.paymentMethod,
            observation: this.manipulateData.observation,
          };
          const formData = new FormData();
          console.log("fichier", this.manipulateData.files);
          if (this.manipulateData.files) {
            formData.append("files", this.manipulateData.files[0]);
          }

          if (this.manipulateData.label) {
            formData.append("label", this.manipulateData.label);
          }

          if (this.manipulateData.amount) {
            formData.append("amount", this.manipulateData.amount);
          }
          if (this.manipulateData.type) {
            formData.append("type", this.manipulateData.type);
          }
          if (this.manipulateData.paymentMethod) {
            formData.append("paymentMethod", this.manipulateData.paymentMethod);
          }
          if (this.manipulateData.observation) {
            formData.append("observation", this.manipulateData.observation);
          }
          if (this.manipulateData._id) {
            await updateMoneyRequest({
              formData,
              id: this.manipulateData._id,
            });
            await this.getRequestUserTransaction({});
            this.$emit("closeAllModal");
          } else {
            await addMoneyRequest({
              schema,
            });
            await this.getRequestUserTransaction({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "videMoneyToUser") {
          const schema = {
            user: this.manipulateData._id,
            balance: this.manipulateData.amount,
            paymentMethod: this.manipulateData.paymentMethod,
          };
          if (this.manipulateData._id) {
            await postVideMoneyToUser({
              schema,
            });
            await this.getUser();
            this.$emit("closeAllModal");
          }
          this.getUserWalletData({});
          this.getUserProfile({});
        } else if (this.manipulateData.modalType == "supplier") {
          const schema = {
            fullName: this.manipulateData.fullName,
            phones: this.manipulateData.phones.split("/"),
            email: this.manipulateData.email,
            country: this.manipulateData.country,
            personContactName: this.manipulateData.personContactName,
            personContactPhone: this.manipulateData.personContactPhone,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateSupplier({
              schema,
              id: this.manipulateData._id,
            });
            await this.getSupplier({});
            this.$emit("closeAllModal");
          } else {
            await addSupplier({
              schema,
            });
            await this.getSupplier({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "transitaire") {
          const schema = {
            fullName: this.manipulateData.fullName,
            phones: this.manipulateData.phones,
            email: this.manipulateData.email,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateTransitaire({
              schema,
              id: this.manipulateData._id,
            });
            await this.getTransitaire();
            this.$emit("closeAllModal");
          } else {
            await addTransitaire({
              schema,
            });
            await this.getTransitaire();
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "store") {
          const schema = {
            name: this.manipulateData.name,
            address: this.manipulateData.address,
            phone: this.manipulateData.phones,
            longitude: this.manipulateData.longitude,
            latitude: this.manipulateData.latitude,
            storeResponsible: defaultMethods.getItemId(
              this.userData,
              this.manipulateData.responsible
            ),
          };
          if (this.manipulateData._id) {
            await updateStore({
              schema,
              id: this.manipulateData._id,
            });
            await this.getStore({});
            this.$emit("closeAllModal");
          } else {
            await addStore({
              schema,
            });
            await this.getStore({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "user") {
          // alert(JSON.stringify( defaultMethods.getItemsId(
          //         this.storeData,
          //         this.manipulateData.stores
          //       )))
          const schema = {
            role: this.manipulateData.role,
            email: this.manipulateData.email,
            stores: this.manipulateData.stores
              ? defaultMethods.getItemsId(
                  this.storeData,
                  this.manipulateData.stores
                )
              : null,
            username: this.manipulateData.username,
            jobTitle: this.manipulateData.jobTitle,
            fullName: this.manipulateData.fullName,
            password: this.manipulateData.password
              ? this.manipulateData.password
              : "p@ssword",
          };
          if (this.manipulateData._id) {
            await updateUser({
              schema,
              id: this.manipulateData._id,
            });
            await this.getUser({});
            this.$emit("closeAllModal");
          } else {
            await addUser({
              schema,
            });
            await this.getUser({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "conteneur") {
          const schema = {
            name: this.manipulateData.name,
            description: this.manipulateData.description,
          };
          if (this.manipulateData._id) {
            await updateConteneur({
              schema,
              id: this.manipulateData._id,
            });
            await this.getConteneur();
            this.$emit("closeAllModal");
          } else {
            await addConteneur({
              schema,
            });
            await this.getConteneur();
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "contrat") {
          if (!this.manipulateData.supplier) {
            defaultMethods.dispatchError(
              this.$store,
              messages.nameEmpty("Fournisseur est requis")
            );
            return;
          }
          if (!this.manipulateData.implementationDate) {
            defaultMethods.dispatchError(
              this.$store,
              messages.nameEmpty("Date de mise en place est requis")
            );
            return;
          }
          if (!this.manipulateData.number) {
            defaultMethods.dispatchError(
              this.$store,
              messages.nameEmpty("Numéro de contrat est requis")
            );
            return;
          }
          const schema = {
            number: this.manipulateData.number,
            implementationDate: this.manipulateData.implementationDate,
            supplier: defaultMethods.getItemId(
              this.supplierData,
              this.manipulateData.supplier
            ),
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateContrat({
              schema,
              id: this.manipulateData._id,
            });
            await this.getContrat({});
            this.$emit("closeAllModal");
          } else {
            await addContrat({
              schema,
            });
            await this.getContrat({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "bl") {
          const schema = {
            number: this.manipulateData.number,
            contractDetail: defaultMethods.getItemId(
              this.contratDataDetails,
              this.manipulateData.contractDetail
            ),
            // numberContainer: this.manipulateData.numberContainer,
            loadingPort: this.manipulateData.loadingPort,
            shipName: this.manipulateData.shipName,
            lineName: this.manipulateData.lineName,
            destination: this.manipulateData.destination,
            lastPosition: this.manipulateData.lastPosition,
            etdPol: this.manipulateData.etdPol,
            eta: this.manipulateData.eta,
            transitaire: defaultMethods.getItemId(
              this.transitaireData,
              this.manipulateData.transitaire
            ),
            containTypes: defaultMethods.getItemFormTypeId(
              this.conteneurData,
              this.formTypes
            ),
            transitaireAmount: this.manipulateData.transitaireAmount
              ? this.manipulateData.transitaireAmount
              : 0,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateBlDetails({
              schema,
              id: this.manipulateData._id,
            });
            await this.getBl({});
            this.$emit("closeAllModal");
          } else {
            await addBlDetails({
              schema,
            });
            await this.getBl({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "conteneurPrincipaleAll" ||
          this.manipulateData.modalType == "addConteneur"
        ) {
          const schema = {
            contractDetail: defaultMethods.getItemId(
              this.contratDataDetails,
              this.manipulateData.contractDetail
            ),
            containType: defaultMethods.getItemId(
              this.conteneurData,
              this.manipulateData.containType
            ),
            bl: defaultMethods.getItemId(this.blData, this.manipulateData.bl),
            name: this.manipulateData.name ? this.manipulateData.name : "",
            transitaire: defaultMethods.getItemId(
              this.transitaireData,
              this.manipulateData.transitaire
            ),
            store: defaultMethods.getItemId(
              this.storeData,
              this.manipulateData.store
            ),
            transitaireAmount: this.manipulateData.transitaireAmount,
            outDate: this.manipulateData.outDate,
            tonsQuantity: this.manipulateData.tonsQuantity,
            quantity: this.manipulateData.quantity,
            etdPol: this.manipulateData.etdPol,
            eta: this.manipulateData.eta,
            shipName: this.manipulateData.shipName,
            // amount: this.manipulateData.amount,
            observation: this.manipulateData.observation,
          };
          if (this.manipulateData._id) {
            await updateContaineurAll({
              schema,
              id: this.manipulateData._id,
            });
            await this.getConteneurAll({ alreadyInStock: "Non" });
            this.$emit("closeAllModal");
          } else {
            await addContaineurAll({
              schema,
            });
            await this.getConteneurAll({ alreadyInStock: "Non" });
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "deleteContainer") {
          for (const item of this.manipulateData.isSelecteds) {
            if (item) {
              await deleteContaineurAll({
                id: item,
              });
            }
          }
          await this.getConteneurAll({ alreadyInStock: "Non" });
          this.$emit("closeAllModal");
        } else if (this.manipulateData.modalType == "sendToStock") {
          for (const item of this.manipulateData.isSelecteds) {
            if (item) {
              const schema = {
                store: defaultMethods.getItemId(
                  this.storeData,
                  this.manipulateData.store
                ),
                outDate: this.manipulateData.outDate,
              };

              await postSendConteneurToStore({
                schema,
                id: item,
              });
              await this.getConteneurAll({ alreadyInStock: "Non" });
              this.$emit("closeAllModal");
            }
          }
        } else if (this.manipulateData.modalType == "customer") {
          const schema = {
            role: this.manipulateData.role,
            email: this.manipulateData.email,
            name: this.manipulateData.name,
            company: this.manipulateData.company,
            address: this.manipulateData.address,
            password: "password",
            phones: this.manipulateData.phones.split("/"),
            username: this.manipulateData.phones,
          };
          if (this.manipulateData._id) {
            await updateCustomer({
              schema,
              id: this.manipulateData._id,
            });
            await this.getCustomerList({});
            this.$emit("closeAllModal");
          } else {
            await addCustomer({
              schema,
            });
            await this.getCustomerList({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "enterProductInStock") {
          if (!this.manipulateData.acknowledgeReceiptQuantity) {
            defaultMethods.dispatchError(
              this.$store,
              messages.nameEmpty("Quantité en entrer est requis")
            );
            return;
          }
          const schema = {
            acknowledgeReceiptQuantity:
              this.manipulateData.acknowledgeReceiptQuantity,
            acknowledgeReceiptDate: this.manipulateData.acknowledgeReceiptDate,
          };

          await postGetConteneurToStore({
            schema,
            id: this.manipulateData._id,
          });
          if (
            this.manipulateData.quantity >
            this.manipulateData.acknowledgeReceiptQuantity
          ) {
            const schema = {
              product: this.manipulateData.productId,
              contain: this.manipulateData._id,
              quantity: this.manipulateData.perteProducts,
              observation: this.manipulateData.observation,
            };
            await saveStockLost({
              schema,
            });
          }
          await this.getConteneurAll({ alreadyInStock: "Oui" });
          this.$emit("closeAllModal");
        } else if (this.manipulateData.modalType == "makeSimulate") {
          await this.getCardDetails({
            customer: defaultMethods.getItemId(
              this.customerListData,
              this.manipulateData.customer
            ),
            status: "Acheté",
            haveReduction: false,
            product: defaultMethods.getItemId(
              this.productData,
              this.manipulateData.product
            ),
            startDate: this.manipulateData.startDate,
            endDate: this.manipulateData.endDate,
          });
        } else if (this.manipulateData.modalType == "customerCommande") {
          // const sommeReductions = this.commandeDettaillesDynamic.reduce(
          //   (acc, current) => {
          //     return Number(acc) + Number(current.reduction);
          //   },
          //   0
          // );
          const schema = {
            customer: defaultMethods.getItemId(
              this.customerListData,
              this.manipulateData.customer
            ),
            // reduction: sommeReductions,
            amount: this.manipulateData.amount,
            observation: this.manipulateData.observation,
          };

          if (this.manipulateData._id) {
            await updateCard({
              schema,
              id: this.manipulateData._id,
            });
          } else {
            await createCard({
              schema,
            }).then(async (res) => {
              if (res.data._id) {
                for (const item of this.commandeDettaillesDynamic) {
                  console.log(item.quantityByStore[0].quantity);
                  if (item.quantityByStore[0].quantity == 0) {
                    const trueAmount =
                      Number(item.unitPrice) * Number(item.quantity);
                    const schema = {
                      cart: res.data._id,
                      product: defaultMethods.getItemId(
                        this.productData,
                        item.product
                      ),
                      // reduction: reductionAmount,
                      amount: trueAmount,
                      // store: defaultMethods.getItemId(
                      //   this.storeData,
                      //   element.store
                      //     .substring(0, element.store.indexOf("("))
                      //     .trim()
                      // ),
                      quantity: item.quantity,
                      // observationReduction: item.observationReduction,
                    };

                    await addCartDetails({ schema });
                  } else {
                    for (const element of item.quantityByStore) {
                      // Calcul du montant réduit en fonction de la quantité
                      const trueAmount =
                        Number(item.unitPrice) * Number(element.quantity);

                      // Calcul de la réduction en fonction de la quantité
                      const reductionAmount = this.calculateReduction(
                        element.quantity,
                        item.reduction,
                        item.quantity
                      );

                      // Montant final après réduction
                      const finalAmount = trueAmount - reductionAmount;

                      const schema = {
                        cart: res.data._id,
                        product: defaultMethods.getItemId(
                          this.productData,
                          item.product
                        ),
                        // reduction: reductionAmount,
                        amount: finalAmount,
                        store: defaultMethods.getItemId(
                          this.storeData,
                          element.store
                            .substring(0, element.store.indexOf("("))
                            .trim()
                        ),
                        quantity: element.quantity,
                        // observationReduction: item.observationReduction,
                      };

                      await addCartDetails({ schema });
                    }
                  }
                }
              }
            });
          }
          await this.getCard({ status: "Attente", alreadyExpired: false });
          this.$emit("closeAllModal");
        } else if (this.manipulateData.modalType == "customerPayeToCaisse") {
          const schema = {
            paymentMethod: this.manipulateData.paymentMethod,
            creditAmount: Number(this.manipulateData.creditAmount),
          };
          if (this.manipulateData._id) {
            await postCustomerPayeToCaisse({
              schema,
              id: this.manipulateData._id,
            });
          }

          await this.getCard({ status: "Envoyé à la caisse" });
          await this.getUserProfile({});
          await this.printBonMagasin({ id: this.manipulateData._id });
          await this.printBonFacture({ id: this.manipulateData._id });
          this.$emit("closeAllModal");
        } else if (this.manipulateData.modalType == "outProductToStock") {
          const schema = {
            cartDetail: this.manipulateData._id,
            observation: this.manipulateData.observation,
            quantity: Number(this.manipulateData.quantity),
          };
          if (this.manipulateData._id) {
            await postMagasiniserOutProductToStock({
              schema,
            });
          }

          await this.getCardDetails({ status: "Acheté" });
          this.$emit("closeAllModal");
        } else if (
          this.manipulateData.modalType == "caisseCrediteCustomerBalance"
        ) {
          const schema = {
            type: "Entrée",
            customer: this.manipulateData.customer,
            amount: this.manipulateData.amount,
            paymentMethod: this.manipulateData.paymentMethod,
            name: this.manipulateData.name,
            banque: this.manipulateData.banque,
            banqueAccountNumber: this.manipulateData.banqueAccountNumber,
          };

          await postCaisseCrediteCustomerBalance({
            schema,
          });
          await this.getCustomerList({});
          await this.getUserProfile();
          this.$emit("closeAllModal");
        } else if (this.manipulateData.modalType == "stockInventory") {
          const formData = new FormData();
          console.log(this.manipulateData.documents[0]);
          if (this.manipulateData.documents[0]) {
            formData.append("documents", this.manipulateData.documents[0]);
          }

          if (this.manipulateData.quantity) {
            formData.append("quantity", this.manipulateData.quantity);
          }
          if (this.manipulateData.isSurPlus) {
            formData.append(
              "isSurPlus",
              this.manipulateData.isSurPlus == "Manquant" ? false : true
            );
          }
          if (this.manipulateData.store) {
            formData.append("store", this.manipulateData.store);
          }
          if (this.manipulateData.observation) {
            formData.append("observation", this.manipulateData.observation);
          }
          if (this.manipulateData.observation) {
            formData.append("product", this.manipulateData.productId);
          }
          // const schema = {
          //   product: this.manipulateData.productId,
          //   quantity: this.manipulateData.quantity,
          //   store: this.manipulateData.store,
          //   observation: this.manipulateData.observation,
          //   documents: this.manipulateData.documents,
          // };

          await magasinAddPerte({
            formData,
          });
          await this.getStoreStock({});
          this.$emit("closeAllModal");
        }
      } catch (error) {
        console.error("Bloc catch : une exception a été attrapée !");
        console.error("My error", error.message);
      } finally {
        console.log("Bloc finally : ce code sera toujours exécuté.");
        this.$emit("show", false);
      }
    },
    async submitFormAdminAccepte() {
      this.$emit("show", true);
      try {
        // alert(this.manipulateData.modalType)
        if (this.manipulateData.modalType == "adminAceptRequestOutMoney") {
          if (this.manipulateData._id) {
            await adminValideComptableDemande({
              id: this.manipulateData._id,
            });
            await this.getRequestUserTransaction({});
            await this.getUserProfile();
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "editeReturnStockRowMagasin"
        ) {
          if (this.manipulateData._id) {
            await magasinValidReturnToStockDemande({
              id: this.manipulateData._id,
            });
            await this.getReturnToStock({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "adminViewManipulateAskReduct"
        ) {
          if (this.manipulateData._id) {
            await adminGiveAccord({
              id: this.manipulateData._id,
            });
            await this.getReductData({});
            this.$emit("closeAllModal");
          }
        } else if (this.manipulateData.modalType == "makeSimulate") {
          const schema = {
            customer: defaultMethods.getItemId(
              this.customerListData,
              this.manipulateData.customer
            ),
            // haveReduction: true,

            product: defaultMethods.getItemId(
              this.productData,
              this.manipulateData.product
            ),
            startDate: this.manipulateData.startDate,
            endDate: this.manipulateData.endDate,
            amount: this.manipulateData.amount,
            observation: this.manipulateData.observation,
          };
          await adminMakeReductForCustomer({
            schema,
          });
          await this.getCardDetails({
            customer: defaultMethods.getItemId(
              this.customerListData,
              this.manipulateData.customer
            ),
            haveReduction: false,
            status: "Acheté",
            product: defaultMethods.getItemId(
              this.productData,
              this.manipulateData.product
            ),
            startDate: this.manipulateData.startDate,
            endDate: this.manipulateData.endDate,
          });
          this.$emit("closeAllModal");
        } else if (
          this.manipulateData.modalType == "editeInventoryMissedDataRow"
        ) {
          if (this.manipulateData._id) {
            await perteSurInventaireAcceptDemande({
              id: this.manipulateData._id,
            });
            await this.getMissingInventory({});
            this.$emit("closeAllModal");
          }
        }
      } catch (error) {
        console.error("Bloc catch : une exception a été attrapée !");
        console.error("My error", error.message);
      } finally {
        console.log("Bloc finally : ce code sera toujours exécuté.");
        this.$emit("show", false);
      }
      this.$emit("show", false);
    },
    async handleClick() {
    await this.submitForm(); // d'abord soumission
    this.$router.push('/parameters');; // puis redirection
  },
    async submitFormAdminReject() {
      this.$emit("show", true);
      try {
        if (this.manipulateData.modalType == "adminAceptRequestOutMoney") {
          if (this.manipulateData._id) {
            await adminRejectComptableDemande({
              id: this.manipulateData._id,
            });
            await this.getRequestUserTransaction({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "adminViewManipulateAskReduct"
        ) {
          if (this.manipulateData._id) {
            await adminRejectAccord({
              id: this.manipulateData._id,
            });
            await this.getReductData({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "editeReturnStockRowMagasin"
        ) {
          if (this.manipulateData._id) {
            await magasinRejectReturnToStockDemande({
              id: this.manipulateData._id,
            });
            await this.getReturnToStock({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "editeInventoryMissedDataRow"
        ) {
          if (this.manipulateData._id) {
            await perteSurInventaireRejectDemande({
              id: this.manipulateData._id,
            });
            await this.getMissingInventory({});
            this.$emit("closeAllModal");
          }
        }
      } catch (error) {
        console.error("Bloc catch : une exception a été attrapée !");
        console.error("My error", error.message);
      } finally {
        console.log("Bloc finally : ce code sera toujours exécuté.");
        this.$emit("show", false);
      }
      this.$emit("show", false);
    },
  },
};
</script>
  
  <style scoped>
/* Styles spécifiques au composant */
</style>
  